export const COUNTRY_OPTIONS = [
  {
    label: "Afghanistan",
    value: "AF",
  },
  {
    label: "Aland Islands",
    value: "AX",
  },
  {
    label: "Albania",
    value: "AL",
  },
  {
    label: "Algeria",
    value: "DZ",
  },
  {
    label: "Andorra",
    value: "AD",
  },
  {
    label: "Angola",
    value: "AO",
  },
  {
    label: "Anguilla",
    value: "AI",
  },
  {
    label: "Antigua And Barbuda",
    value: "AG",
  },
  {
    label: "Argentina",
    value: "AR",
  },
  {
    label: "Armenia",
    value: "AM",
  },
  {
    label: "Aruba",
    value: "AW",
  },
  {
    label: "Ascension Island",
    value: "AC",
  },
  {
    label: "Australia",
    value: "AU",
  },
  {
    label: "Austria",
    value: "AT",
  },
  {
    label: "Azerbaijan",
    value: "AZ",
  },
  {
    label: "Bahamas",
    value: "BS",
  },
  {
    label: "Bahrain",
    value: "BH",
  },
  {
    label: "Bangladesh",
    value: "BD",
  },
  {
    label: "Barbados",
    value: "BB",
  },
  {
    label: "Belarus",
    value: "BY",
  },
  {
    label: "Belgium",
    value: "BE",
  },
  {
    label: "Belize",
    value: "BZ",
  },
  {
    label: "Benin",
    value: "BJ",
  },
  {
    label: "Bermuda",
    value: "BM",
  },
  {
    label: "Bhutan",
    value: "BT",
  },
  {
    label: "Bolivia",
    value: "BO",
  },
  {
    label: "Bosnia And Herzegovina",
    value: "BA",
  },
  {
    label: "Botswana",
    value: "BW",
  },
  {
    label: "Bouvet Island",
    value: "BV",
  },
  {
    label: "Brazil",
    value: "BR",
  },
  {
    label: "British Indian Ocean Territory",
    value: "IO",
  },
  {
    label: "Brunei",
    value: "BN",
  },
  {
    label: "Bulgaria",
    value: "BG",
  },
  {
    label: "Burkina Faso",
    value: "BF",
  },
  {
    label: "Burundi",
    value: "BI",
  },
  {
    label: "Cambodia",
    value: "KH",
  },
  {
    label: "Canada",
    value: "CA",
  },
  {
    label: "Cape Verde",
    value: "CV",
  },
  {
    label: "Caribbean Netherlands",
    value: "BQ",
  },
  {
    label: "Cayman Islands",
    value: "KY",
  },
  {
    label: "Central African Republic",
    value: "CF",
  },
  {
    label: "Chad",
    value: "TD",
  },
  {
    label: "Chile",
    value: "CL",
  },
  {
    label: "China",
    value: "CN",
  },
  {
    label: "Christmas Island",
    value: "CX",
  },
  {
    label: "Cocos (Keeling) Islands",
    value: "CC",
  },
  {
    label: "Colombia",
    value: "CO",
  },
  {
    label: "Comoros",
    value: "KM",
  },
  {
    label: "Congo",
    value: "CG",
  },
  {
    label: "Congo, The Democratic Republic Of The",
    value: "CD",
  },
  {
    label: "Cook Islands",
    value: "CK",
  },
  {
    label: "Costa Rica",
    value: "CR",
  },
  {
    label: "Croatia",
    value: "HR",
  },
  {
    label: "Cuba",
    value: "CU",
  },
  {
    label: "Curaçao",
    value: "CW",
  },
  {
    label: "Cyprus",
    value: "CY",
  },
  {
    label: "Czech Republic",
    value: "CZ",
  },
  {
    label: "Côte d'Ivoire",
    value: "CI",
  },
  {
    label: "Denmark",
    value: "DK",
  },
  {
    label: "Djibouti",
    value: "DJ",
  },
  {
    label: "Dominica",
    value: "DM",
  },
  {
    label: "Dominican Republic",
    value: "DO",
  },
  {
    label: "Ecuador",
    value: "EC",
  },
  {
    label: "Egypt",
    value: "EG",
  },
  {
    label: "El Salvador",
    value: "SV",
  },
  {
    label: "Equatorial Guinea",
    value: "GQ",
  },
  {
    label: "Eritrea",
    value: "ER",
  },
  {
    label: "Estonia",
    value: "EE",
  },
  {
    label: "Eswatini",
    value: "SZ",
  },
  {
    label: "Ethiopia",
    value: "ET",
  },
  {
    label: "Falkland Islands (Malvinas)",
    value: "FK",
  },
  {
    label: "Faroe Islands",
    value: "FO",
  },
  {
    label: "Fiji",
    value: "FJ",
  },
  {
    label: "Finland",
    value: "FI",
  },
  {
    label: "France",
    value: "FR",
  },
  {
    label: "French Guiana",
    value: "GF",
  },
  {
    label: "French Polynesia",
    value: "PF",
  },
  {
    label: "French Southern Territories",
    value: "TF",
  },
  {
    label: "Gabon",
    value: "GA",
  },
  {
    label: "Gambia",
    value: "GM",
  },
  {
    label: "Georgia",
    value: "GE",
  },
  {
    label: "Germany",
    value: "DE",
  },
  {
    label: "Ghana",
    value: "GH",
  },
  {
    label: "Gibraltar",
    value: "GI",
  },
  {
    label: "Greece",
    value: "GR",
  },
  {
    label: "Greenland",
    value: "GL",
  },
  {
    label: "Grenada",
    value: "GD",
  },
  {
    label: "Guadeloupe",
    value: "GP",
  },
  {
    label: "Guatemala",
    value: "GT",
  },
  {
    label: "Guernsey",
    value: "GG",
  },
  {
    label: "Guinea",
    value: "GN",
  },
  {
    label: "Guinea Bissau",
    value: "GW",
  },
  {
    label: "Guyana",
    value: "GY",
  },
  {
    label: "Haiti",
    value: "HT",
  },
  {
    label: "Heard Island And Mcdonald Islands",
    value: "HM",
  },
  {
    label: "Holy See (Vatican City State)",
    value: "VA",
  },
  {
    label: "Honduras",
    value: "HN",
  },
  {
    label: "Hong Kong",
    value: "HK",
  },
  {
    label: "Hungary",
    value: "HU",
  },
  {
    label: "Iceland",
    value: "IS",
  },
  {
    label: "India",
    value: "IN",
  },
  {
    label: "Indonesia",
    value: "ID",
  },
  {
    label: "Iran, Islamic Republic Of",
    value: "IR",
  },
  {
    label: "Iraq",
    value: "IQ",
  },
  {
    label: "Ireland",
    value: "IE",
  },
  {
    label: "Isle Of Man",
    value: "IM",
  },
  {
    label: "Israel",
    value: "IL",
  },
  {
    label: "Italy",
    value: "IT",
  },
  {
    label: "Jamaica",
    value: "JM",
  },
  {
    label: "Japan",
    value: "JP",
  },
  {
    label: "Jersey",
    value: "JE",
  },
  {
    label: "Jordan",
    value: "JO",
  },
  {
    label: "Kazakhstan",
    value: "KZ",
  },
  {
    label: "Kenya",
    value: "KE",
  },
  {
    label: "Kiribati",
    value: "KI",
  },
  {
    label: "Korea, Democratic People's Republic Of",
    value: "KP",
  },
  {
    label: "Kosovo",
    value: "XK",
  },
  {
    label: "Kuwait",
    value: "KW",
  },
  {
    label: "Kyrgyzstan",
    value: "KG",
  },
  {
    label: "Lao People's Democratic Republic",
    value: "LA",
  },
  {
    label: "Latvia",
    value: "LV",
  },
  {
    label: "Lebanon",
    value: "LB",
  },
  {
    label: "Lesotho",
    value: "LS",
  },
  {
    label: "Liberia",
    value: "LR",
  },
  {
    label: "Libyan Arab Jamahiriya",
    value: "LY",
  },
  {
    label: "Liechtenstein",
    value: "LI",
  },
  {
    label: "Lithuania",
    value: "LT",
  },
  {
    label: "Luxembourg",
    value: "LU",
  },
  {
    label: "Macao",
    value: "MO",
  },
  {
    label: "Madagascar",
    value: "MG",
  },
  {
    label: "Malawi",
    value: "MW",
  },
  {
    label: "Malaysia",
    value: "MY",
  },
  {
    label: "Maldives",
    value: "MV",
  },
  {
    label: "Mali",
    value: "ML",
  },
  {
    label: "Malta",
    value: "MT",
  },
  {
    label: "Martinique",
    value: "MQ",
  },
  {
    label: "Mauritania",
    value: "MR",
  },
  {
    label: "Mauritius",
    value: "MU",
  },
  {
    label: "Mayotte",
    value: "YT",
  },
  {
    label: "Mexico",
    value: "MX",
  },
  {
    label: "Moldova, Republic of",
    value: "MD",
  },
  {
    label: "Monaco",
    value: "MC",
  },
  {
    label: "Mongolia",
    value: "MN",
  },
  {
    label: "Montenegro",
    value: "ME",
  },
  {
    label: "Montserrat",
    value: "MS",
  },
  {
    label: "Morocco",
    value: "MA",
  },
  {
    label: "Mozambique",
    value: "MZ",
  },
  {
    label: "Myanmar",
    value: "MM",
  },
  {
    label: "Namibia",
    value: "NA",
  },
  {
    label: "Nauru",
    value: "NR",
  },
  {
    label: "Nepal",
    value: "NP",
  },
  {
    label: "Netherlands",
    value: "NL",
  },
  {
    label: "Netherlands Antilles",
    value: "AN",
  },
  {
    label: "New Caledonia",
    value: "NC",
  },
  {
    label: "New Zealand",
    value: "NZ",
  },
  {
    label: "Nicaragua",
    value: "NI",
  },
  {
    label: "Niger",
    value: "NE",
  },
  {
    label: "Nigeria",
    value: "NG",
  },
  {
    label: "Niue",
    value: "NU",
  },
  {
    label: "Norfolk Island",
    value: "NF",
  },
  {
    label: "North Macedonia",
    value: "MK",
  },
  {
    label: "Norway",
    value: "NO",
  },
  {
    label: "Oman",
    value: "OM",
  },
  {
    label: "Pakistan",
    value: "PK",
  },
  {
    label: "Palestinian Territory, Occupied",
    value: "PS",
  },
  {
    label: "Panama",
    value: "PA",
  },
  {
    label: "Papua New Guinea",
    value: "PG",
  },
  {
    label: "Paraguay",
    value: "PY",
  },
  {
    label: "Peru",
    value: "PE",
  },
  {
    label: "Philippines",
    value: "PH",
  },
  {
    label: "Pitcairn",
    value: "PN",
  },
  {
    label: "Poland",
    value: "PL",
  },
  {
    label: "Portugal",
    value: "PT",
  },
  {
    label: "Qatar",
    value: "QA",
  },
  {
    label: "Republic of Cameroon",
    value: "CM",
  },
  {
    label: "Reunion",
    value: "RE",
  },
  {
    label: "Romania",
    value: "RO",
  },
  {
    label: "Russia",
    value: "RU",
  },
  {
    label: "Rwanda",
    value: "RW",
  },
  {
    label: "Saint Barthélemy",
    value: "BL",
  },
  {
    label: "Saint Helena",
    value: "SH",
  },
  {
    label: "Saint Kitts And Nevis",
    value: "KN",
  },
  {
    label: "Saint Lucia",
    value: "LC",
  },
  {
    label: "Saint Martin",
    value: "MF",
  },
  {
    label: "Saint Pierre And Miquelon",
    value: "PM",
  },
  {
    label: "Samoa",
    value: "WS",
  },
  {
    label: "San Marino",
    value: "SM",
  },
  {
    label: "Sao Tome And Principe",
    value: "ST",
  },
  {
    label: "Saudi Arabia",
    value: "SA",
  },
  {
    label: "Senegal",
    value: "SN",
  },
  {
    label: "Serbia",
    value: "RS",
  },
  {
    label: "Seychelles",
    value: "SC",
  },
  {
    label: "Sierra Leone",
    value: "SL",
  },
  {
    label: "Singapore",
    value: "SG",
  },
  {
    label: "Sint Maarten",
    value: "SX",
  },
  {
    label: "Slovakia",
    value: "SK",
  },
  {
    label: "Slovenia",
    value: "SI",
  },
  {
    label: "Solomon Islands",
    value: "SB",
  },
  {
    label: "Somalia",
    value: "SO",
  },
  {
    label: "South Africa",
    value: "ZA",
  },
  {
    label: "South Georgia And The South Sandwich Islands",
    value: "GS",
  },
  {
    label: "South Korea",
    value: "KR",
  },
  {
    label: "South Sudan",
    value: "SS",
  },
  {
    label: "Spain",
    value: "ES",
  },
  {
    label: "Sri Lanka",
    value: "LK",
  },
  {
    label: "St. Vincent",
    value: "VC",
  },
  {
    label: "Sudan",
    value: "SD",
  },
  {
    label: "Suriname",
    value: "SR",
  },
  {
    label: "Svalbard And Jan Mayen",
    value: "SJ",
  },
  {
    label: "Sweden",
    value: "SE",
  },
  {
    label: "Switzerland",
    value: "CH",
  },
  {
    label: "Syria",
    value: "SY",
  },
  {
    label: "Taiwan",
    value: "TW",
  },
  {
    label: "Tajikistan",
    value: "TJ",
  },
  {
    label: "Tanzania, United Republic Of",
    value: "TZ",
  },
  {
    label: "Thailand",
    value: "TH",
  },
  {
    label: "Timor Leste",
    value: "TL",
  },
  {
    label: "Togo",
    value: "TG",
  },
  {
    label: "Tokelau",
    value: "TK",
  },
  {
    label: "Tonga",
    value: "TO",
  },
  {
    label: "Trinidad and Tobago",
    value: "TT",
  },
  {
    label: "Tristan da Cunha",
    value: "TA",
  },
  {
    label: "Tunisia",
    value: "TN",
  },
  {
    label: "Turkey",
    value: "TR",
  },
  {
    label: "Turkmenistan",
    value: "TM",
  },
  {
    label: "Turks and Caicos Islands",
    value: "TC",
  },
  {
    label: "Tuvalu",
    value: "TV",
  },
  {
    label: "Uganda",
    value: "UG",
  },
  {
    label: "Ukraine",
    value: "UA",
  },
  {
    label: "United Arab Emirates",
    value: "AE",
  },
  {
    label: "United Kingdom",
    value: "GB",
  },
  {
    label: "United States",
    value: "US",
  },
  {
    label: "United States Minor Outlying Islands",
    value: "UM",
  },
  {
    label: "Uruguay",
    value: "UY",
  },
  {
    label: "Uzbekistan",
    value: "UZ",
  },
  {
    label: "Vanuatu",
    value: "VU",
  },
  {
    label: "Venezuela",
    value: "VE",
  },
  {
    label: "Vietnam",
    value: "VN",
  },
  {
    label: "Virgin Islands, British",
    value: "VG",
  },
  {
    label: "Wallis And Futuna",
    value: "WF",
  },
  {
    label: "Western Sahara",
    value: "EH",
  },
  {
    label: "Yemen",
    value: "YE",
  },
  {
    label: "Zambia",
    value: "ZM",
  },
  {
    label: "Zimbabwe",
    value: "ZW",
  },
];

export const COUNTRY_DICT = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua And Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AC: "Ascension Island",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia And Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CA: "Canada",
  CV: "Cape Verde",
  BQ: "Caribbean Netherlands",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, The Democratic Republic Of The",
  CK: "Cook Islands",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  CI: "Côte d'Ivoire",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island And Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic Of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle Of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic Of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: "North Macedonia",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  QA: "Qatar",
  CM: "Republic of Cameroon",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russia",
  RW: "Rwanda",
  BL: "Saint Barthélemy",
  SH: "Saint Helena",
  KN: "Saint Kitts And Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre And Miquelon",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome And Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia And The South Sandwich Islands",
  KR: "South Korea",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  VC: "St. Vincent",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard And Jan Mayen",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic Of",
  TH: "Thailand",
  TL: "Timor Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TA: "Tristan da Cunha",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  WF: "Wallis And Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const PROVINCE_OPTIONS = {
  "KP": [],
  "SY": [],
  "AN": [],
  "AF": [],
  "AX": [],
  "AL": [],
  "DZ": [],
  "AD": [],
  "AO": [],
  "AI": [],
  "AG": [],
  "AR": [
    {
      "label": "Salta",
      "value": "A"
    },
    {
      "label": "Buenos Aires",
      "value": "B"
    },
    {
      "label": "Ciudad Autónoma de Buenos Aires",
      "value": "C"
    },
    {
      "label": "San Luis",
      "value": "D"
    },
    {
      "label": "Entre Ríos",
      "value": "E"
    },
    {
      "label": "La Rioja",
      "value": "F"
    },
    {
      "label": "Santiago Del Estero",
      "value": "G"
    },
    {
      "label": "Chaco",
      "value": "H"
    },
    {
      "label": "San Juan",
      "value": "J"
    },
    {
      "label": "Catamarca",
      "value": "K"
    },
    {
      "label": "La Pampa",
      "value": "L"
    },
    {
      "label": "Mendoza",
      "value": "M"
    },
    {
      "label": "Misiones",
      "value": "N"
    },
    {
      "label": "Formosa",
      "value": "P"
    },
    {
      "label": "Neuquén",
      "value": "Q"
    },
    {
      "label": "Río Negro",
      "value": "R"
    },
    {
      "label": "Santa Fe",
      "value": "S"
    },
    {
      "label": "Tucumán",
      "value": "T"
    },
    {
      "label": "Chubut",
      "value": "U"
    },
    {
      "label": "Tierra Del Fuego",
      "value": "V"
    },
    {
      "label": "Corrientes",
      "value": "W"
    },
    {
      "label": "Córdoba",
      "value": "X"
    },
    {
      "label": "Jujuy",
      "value": "Y"
    },
    {
      "label": "Santa Cruz",
      "value": "Z"
    }
  ],
  "AM": [],
  "AW": [],
  "AU": [
    {
      "label": "Australian Capital Territory",
      "value": "ACT"
    },
    {
      "label": "New South Wales",
      "value": "NSW"
    },
    {
      "label": "Northern Territory",
      "value": "NT"
    },
    {
      "label": "Queensland",
      "value": "QLD"
    },
    {
      "label": "South Australia",
      "value": "SA"
    },
    {
      "label": "Tasmania",
      "value": "TAS"
    },
    {
      "label": "Victoria",
      "value": "VIC"
    },
    {
      "label": "Western Australia",
      "value": "WA"
    }
  ],
  "AT": [],
  "AZ": [],
  "BS": [],
  "BH": [],
  "BD": [],
  "BB": [],
  "BY": [],
  "BE": [],
  "BZ": [],
  "BJ": [],
  "BM": [],
  "BT": [],
  "BO": [],
  "BA": [],
  "BW": [],
  "BV": [],
  "BR": [
    {
      "label": "Acre",
      "value": "AC"
    },
    {
      "label": "Alagoas",
      "value": "AL"
    },
    {
      "label": "Amazonas",
      "value": "AM"
    },
    {
      "label": "Amapá",
      "value": "AP"
    },
    {
      "label": "Bahia",
      "value": "BA"
    },
    {
      "label": "Ceará",
      "value": "CE"
    },
    {
      "label": "Distrito Federal",
      "value": "DF"
    },
    {
      "label": "Espírito Santo",
      "value": "ES"
    },
    {
      "label": "Goiás",
      "value": "GO"
    },
    {
      "label": "Maranhão",
      "value": "MA"
    },
    {
      "label": "Minas Gerais",
      "value": "MG"
    },
    {
      "label": "Mato Grosso do Sul",
      "value": "MS"
    },
    {
      "label": "Mato Grosso",
      "value": "MT"
    },
    {
      "label": "Pará",
      "value": "PA"
    },
    {
      "label": "Paraíba",
      "value": "PB"
    },
    {
      "label": "Pernambuco",
      "value": "PE"
    },
    {
      "label": "Piauí",
      "value": "PI"
    },
    {
      "label": "Paraná",
      "value": "PR"
    },
    {
      "label": "Rio de Janeiro",
      "value": "RJ"
    },
    {
      "label": "Rio Grande do Norte",
      "value": "RN"
    },
    {
      "label": "Rondônia",
      "value": "RO"
    },
    {
      "label": "Roraima",
      "value": "RR"
    },
    {
      "label": "Rio Grande do Sul",
      "value": "RS"
    },
    {
      "label": "Santa Catarina",
      "value": "SC"
    },
    {
      "label": "Sergipe",
      "value": "SE"
    },
    {
      "label": "São Paulo",
      "value": "SP"
    },
    {
      "label": "Tocantins",
      "value": "TO"
    }
  ],
  "IO": [],
  "BN": [],
  "BG": [],
  "BF": [],
  "BI": [],
  "KH": [],
  "CA": [
    {
      "label": "Alberta",
      "value": "AB"
    },
    {
      "label": "British Columbia",
      "value": "BC"
    },
    {
      "label": "Manitoba",
      "value": "MB"
    },
    {
      "label": "New Brunswick",
      "value": "NB"
    },
    {
      "label": "Newfoundland and Labrador",
      "value": "NL"
    },
    {
      "label": "Nova Scotia",
      "value": "NS"
    },
    {
      "label": "Northwest Territories",
      "value": "NT"
    },
    {
      "label": "Nunavut",
      "value": "NU"
    },
    {
      "label": "Ontario",
      "value": "ON"
    },
    {
      "label": "Prince Edward Island",
      "value": "PE"
    },
    {
      "label": "Quebec",
      "value": "QC"
    },
    {
      "label": "Saskatchewan",
      "value": "SK"
    },
    {
      "label": "Yukon",
      "value": "YT"
    }
  ],
  "CV": [],
  "BQ": [],
  "KY": [],
  "CF": [],
  "TD": [],
  "CL": [
    {
      "label": "Aysén",
      "value": "AI"
    },
    {
      "label": "Antofagasta",
      "value": "AN"
    },
    {
      "label": "Arica and Parinacota",
      "value": "AP"
    },
    {
      "label": "Araucanía",
      "value": "AR"
    },
    {
      "label": "Atacama",
      "value": "AT"
    },
    {
      "label": "Biobío",
      "value": "BI"
    },
    {
      "label": "Coquimbo",
      "value": "CO"
    },
    {
      "label": "O'Higgins",
      "value": "LI"
    },
    {
      "label": "Los Lagos",
      "value": "LL"
    },
    {
      "label": "Los Ríos",
      "value": "LR"
    },
    {
      "label": "Magallanes",
      "value": "MA"
    },
    {
      "label": "Maule",
      "value": "ML"
    },
    {
      "label": "Ñuble",
      "value": "NB"
    },
    {
      "label": "Santiago",
      "value": "RM"
    },
    {
      "label": "Tarapacá",
      "value": "TA"
    },
    {
      "label": "Valparaíso",
      "value": "VS"
    }
  ],
  "CN": [
    {
      "label": "Anhui",
      "value": "AH"
    },
    {
      "label": "Beijing",
      "value": "BJ"
    },
    {
      "label": "Chongqing",
      "value": "CQ"
    },
    {
      "label": "Fujian",
      "value": "FJ"
    },
    {
      "label": "Guangdong",
      "value": "GD"
    },
    {
      "label": "Gansu",
      "value": "GS"
    },
    {
      "label": "Guangxi",
      "value": "GX"
    },
    {
      "label": "Guizhou",
      "value": "GZ"
    },
    {
      "label": "Henan",
      "value": "HA"
    },
    {
      "label": "Hubei",
      "value": "HB"
    },
    {
      "label": "Hebei",
      "value": "HE"
    },
    {
      "label": "Hainan",
      "value": "HI"
    },
    {
      "label": "Heilongjiang",
      "value": "HL"
    },
    {
      "label": "Hunan",
      "value": "HN"
    },
    {
      "label": "Jilin",
      "value": "JL"
    },
    {
      "label": "Jiangsu",
      "value": "JS"
    },
    {
      "label": "Jiangxi",
      "value": "JX"
    },
    {
      "label": "Liaoning",
      "value": "LN"
    },
    {
      "label": "Inner Mongolia",
      "value": "NM"
    },
    {
      "label": "Ningxia",
      "value": "NX"
    },
    {
      "label": "Qinghai",
      "value": "QH"
    },
    {
      "label": "Sichuan",
      "value": "SC"
    },
    {
      "label": "Shandong",
      "value": "SD"
    },
    {
      "label": "Shanghai",
      "value": "SH"
    },
    {
      "label": "Shaanxi",
      "value": "SN"
    },
    {
      "label": "Shanxi",
      "value": "SX"
    },
    {
      "label": "Tianjin",
      "value": "TJ"
    },
    {
      "label": "Xinjiang",
      "value": "XJ"
    },
    {
      "label": "Yunnan",
      "value": "YN"
    },
    {
      "label": "Xizang",
      "value": "YZ"
    },
    {
      "label": "Zhejiang",
      "value": "ZJ"
    }
  ],
  "CX": [],
  "CC": [],
  "CO": [
    {
      "label": "Amazonas",
      "value": "AMA"
    },
    {
      "label": "Antioquia",
      "value": "ANT"
    },
    {
      "label": "Arauca",
      "value": "ARA"
    },
    {
      "label": "Atlántico",
      "value": "ATL"
    },
    {
      "label": "Bolívar",
      "value": "BOL"
    },
    {
      "label": "Boyacá",
      "value": "BOY"
    },
    {
      "label": "Caldas",
      "value": "CAL"
    },
    {
      "label": "Caquetá",
      "value": "CAQ"
    },
    {
      "label": "Casanare",
      "value": "CAS"
    },
    {
      "label": "Cauca",
      "value": "CAU"
    },
    {
      "label": "Cesar",
      "value": "CES"
    },
    {
      "label": "Chocó",
      "value": "CHO"
    },
    {
      "label": "Córdoba",
      "value": "COR"
    },
    {
      "label": "Cundinamarca",
      "value": "CUN"
    },
    {
      "label": "Bogotá, D.C.",
      "value": "DC"
    },
    {
      "label": "Guainía",
      "value": "GUA"
    },
    {
      "label": "Guaviare",
      "value": "GUV"
    },
    {
      "label": "Huila",
      "value": "HUI"
    },
    {
      "label": "La Guajira",
      "value": "LAG"
    },
    {
      "label": "Magdalena",
      "value": "MAG"
    },
    {
      "label": "Meta",
      "value": "MET"
    },
    {
      "label": "Nariño",
      "value": "NAR"
    },
    {
      "label": "Norte de Santander",
      "value": "NSA"
    },
    {
      "label": "Putumayo",
      "value": "PUT"
    },
    {
      "label": "Quindío",
      "value": "QUI"
    },
    {
      "label": "Risaralda",
      "value": "RIS"
    },
    {
      "label": "Santander",
      "value": "SAN"
    },
    {
      "label": "San Andrés, Providencia y Santa Catalina",
      "value": "SAP"
    },
    {
      "label": "Sucre",
      "value": "SUC"
    },
    {
      "label": "Tolima",
      "value": "TOL"
    },
    {
      "label": "Valle del Cauca",
      "value": "VAC"
    },
    {
      "label": "Vaupés",
      "value": "VAU"
    },
    {
      "label": "Vichada",
      "value": "VID"
    }
  ],
  "KM": [],
  "CG": [],
  "CD": [],
  "CK": [],
  "CU": [],
  "HM": [],
  "IR": [],
  "CR": [
    {
      "label": "Alajuela",
      "value": "CR-A"
    },
    {
      "label": "Cartago",
      "value": "CR-C"
    },
    {
      "label": "Guanacaste",
      "value": "CR-G"
    },
    {
      "label": "Heredia",
      "value": "CR-H"
    },
    {
      "label": "Limón",
      "value": "CR-L"
    },
    {
      "label": "Puntarenas",
      "value": "CR-P"
    },
    {
      "label": "San José",
      "value": "CR-SJ"
    }
  ],
  "HR": [],
  "CW": [],
  "CY": [],
  "CZ": [],
  "CI": [],
  "DK": [],
  "DJ": [],
  "DM": [],
  "DO": [],
  "EC": [],
  "EG": [
    {
      "label": "Alexandria",
      "value": "ALX"
    },
    {
      "label": "Aswan",
      "value": "ASN"
    },
    {
      "label": "Asyut",
      "value": "AST"
    },
    {
      "label": "Red Sea",
      "value": "BA"
    },
    {
      "label": "Beheira",
      "value": "BH"
    },
    {
      "label": "Beni Suef",
      "value": "BNS"
    },
    {
      "label": "Cairo",
      "value": "C"
    },
    {
      "label": "Dakahlia",
      "value": "DK"
    },
    {
      "label": "Damietta",
      "value": "DT"
    },
    {
      "label": "Faiyum",
      "value": "FYM"
    },
    {
      "label": "Gharbia",
      "value": "GH"
    },
    {
      "label": "Giza",
      "value": "GZ"
    },
    {
      "label": "Helwan",
      "value": "HU"
    },
    {
      "label": "Ismailia",
      "value": "IS"
    },
    {
      "label": "South Sinai",
      "value": "JS"
    },
    {
      "label": "Qalyubia",
      "value": "KB"
    },
    {
      "label": "Kafr el-Sheikh",
      "value": "KFS"
    },
    {
      "label": "Qena",
      "value": "KN"
    },
    {
      "label": "Luxor",
      "value": "LX"
    },
    {
      "label": "Minya",
      "value": "MN"
    },
    {
      "label": "Monufia",
      "value": "MNF"
    },
    {
      "label": "Matrouh",
      "value": "MT"
    },
    {
      "label": "Port Said",
      "value": "PTS"
    },
    {
      "label": "Sohag",
      "value": "SHG"
    },
    {
      "label": "Al Sharqia",
      "value": "SHR"
    },
    {
      "label": "North Sinai",
      "value": "SIN"
    },
    {
      "label": "6th of October",
      "value": "SU"
    },
    {
      "label": "Suez",
      "value": "SUZ"
    },
    {
      "label": "New Valley",
      "value": "WAD"
    }
  ],
  "SV": [
    {
      "label": "Ahuachapán",
      "value": "SV-AH"
    },
    {
      "label": "Cabañas",
      "value": "SV-CA"
    },
    {
      "label": "Chalatenango",
      "value": "SV-CH"
    },
    {
      "label": "Cuscatlán",
      "value": "SV-CU"
    },
    {
      "label": "La Libertad",
      "value": "SV-LI"
    },
    {
      "label": "Morazán",
      "value": "SV-MO"
    },
    {
      "label": "La Paz",
      "value": "SV-PA"
    },
    {
      "label": "Santa Ana",
      "value": "SV-SA"
    },
    {
      "label": "San Miguel",
      "value": "SV-SM"
    },
    {
      "label": "Sonsonate",
      "value": "SV-SO"
    },
    {
      "label": "San Salvador",
      "value": "SV-SS"
    },
    {
      "label": "San Vicente",
      "value": "SV-SV"
    },
    {
      "label": "La Unión",
      "value": "SV-UN"
    },
    {
      "label": "Usulután",
      "value": "SV-US"
    }
  ],
  "GQ": [],
  "ER": [],
  "EE": [],
  "SZ": [],
  "ET": [],
  "FK": [],
  "FO": [],
  "FJ": [],
  "FI": [],
  "FR": [
    {
        "label": "Auvergne-Rhône-Alpes\n",
        "value": "84"
    },
    {
        "label": "Bourgogne-Franche-Comté",
        "value": "27\t"
    },
    {
        "label": "Brittany (Bretagne)",
        "value": "53"
    },
    {
        "label": "Centre-Val de Loire",
        "value": "24"
    },
    {
        "label": "Corsica (Corse)",
        "value": "94"
    },
    {
        "label": "Grand Est",
        "value": "44"
    },
    {
        "label": "Hauts-de-France",
        "value": "32"
    },
    {
        "label": "Île-de-France",
        "value": "11"
    },
    {
        "label": "Normandy (Normandie)",
        "value": "28"
    },
    {
        "label": "Nouvelle-Aquitaine",
        "value": "75"
    },
    {
        "label": "Occitanie",
        "value": "76"
    },
    {
        "label": "Pays de la Loire",
        "value": "52"
    },
    {
        "label": "Provence-Alpes-Côte d'Azur",
        "value": "93"
    },
    {
        "label": "Guadeloupe",
        "value": "01"
    },
    {
        "label": "Martinique",
        "value": "02"
    },
    {
        "label": "Guyane (French Guiana)",
        "value": "03"
    },
    {
        "label": "La Réunion",
        "value": "04"
    },
    {
        "label": "Mayotte",
        "value": "06"
    }
  ],
  "GF": [],
  "PF": [],
  "TF": [],
  "GA": [],
  "GM": [],
  "GE": [],
  "DE": [],
  "GH": [],
  "GI": [],
  "GR": [],
  "GL": [],
  "GD": [],
  "GP": [],
  "GT": [
    {
      "label": "Alta Verapaz",
      "value": "AVE"
    },
    {
      "label": "Baja Verapaz",
      "value": "BVE"
    },
    {
      "label": "Chimaltenango",
      "value": "CMT"
    },
    {
      "label": "Chiquimula",
      "value": "CQM"
    },
    {
      "label": "El Progreso",
      "value": "EPR"
    },
    {
      "label": "Escuintla",
      "value": "ESC"
    },
    {
      "label": "Guatemala",
      "value": "GUA"
    },
    {
      "label": "Huehuetenango",
      "value": "HUE"
    },
    {
      "label": "Izabal",
      "value": "IZA"
    },
    {
      "label": "Jalapa",
      "value": "JAL"
    },
    {
      "label": "Jutiapa",
      "value": "JUT"
    },
    {
      "label": "Petén",
      "value": "PET"
    },
    {
      "label": "Quetzaltenango",
      "value": "QUE"
    },
    {
      "label": "Quiché",
      "value": "QUI"
    },
    {
      "label": "Retalhuleu",
      "value": "RET"
    },
    {
      "label": "Sacatepéquez",
      "value": "SAC"
    },
    {
      "label": "San Marcos",
      "value": "SMA"
    },
    {
      "label": "Sololá",
      "value": "SOL"
    },
    {
      "label": "Santa Rosa",
      "value": "SRO"
    },
    {
      "label": "Suchitepéquez",
      "value": "SUC"
    },
    {
      "label": "Totonicapán",
      "value": "TOT"
    },
    {
      "label": "Zacapa",
      "value": "ZAC"
    }
  ],
  "GG": [],
  "GN": [],
  "GW": [],
  "GY": [],
  "HT": [],
  "VA": [],
  "HN": [],
  "HK": [
    {
      "label": "Hong Kong Island",
      "value": "HK"
    },
    {
      "label": "Kowloon",
      "value": "KL"
    },
    {
      "label": "New Territories",
      "value": "NT"
    }
  ],
  "HU": [],
  "IS": [],
  "IN": [
    {
      "label": "Andaman and Nicobar Islands",
      "value": "AN"
    },
    {
      "label": "Andhra Pradesh",
      "value": "AP"
    },
    {
      "label": "Arunachal Pradesh",
      "value": "AR"
    },
    {
      "label": "Assam",
      "value": "AS"
    },
    {
      "label": "Bihar",
      "value": "BR"
    },
    {
      "label": "Chhattisgarh",
      "value": "CG"
    },
    {
      "label": "Chandigarh",
      "value": "CH"
    },
    {
      "label": "Daman and Diu",
      "value": "DD"
    },
    {
      "label": "Delhi",
      "value": "DL"
    },
    {
      "label": "Dadra and Nagar Haveli",
      "value": "DN"
    },
    {
      "label": "Goa",
      "value": "GA"
    },
    {
      "label": "Gujarat",
      "value": "GJ"
    },
    {
      "label": "Himachal Pradesh",
      "value": "HP"
    },
    {
      "label": "Haryana",
      "value": "HR"
    },
    {
      "label": "Jharkhand",
      "value": "JH"
    },
    {
      "label": "Jammu and Kashmir",
      "value": "JK"
    },
    {
      "label": "Karnataka",
      "value": "KA"
    },
    {
      "label": "Kerala",
      "value": "KL"
    },
    {
      "label": "Ladakh",
      "value": "LA"
    },
    {
      "label": "Lakshadweep",
      "value": "LD"
    },
    {
      "label": "Maharashtra",
      "value": "MH"
    },
    {
      "label": "Meghalaya",
      "value": "ML"
    },
    {
      "label": "Manipur",
      "value": "MN"
    },
    {
      "label": "Madhya Pradesh",
      "value": "MP"
    },
    {
      "label": "Mizoram",
      "value": "MZ"
    },
    {
      "label": "Nagaland",
      "value": "NL"
    },
    {
      "label": "Odisha",
      "value": "OR"
    },
    {
      "label": "Punjab",
      "value": "PB"
    },
    {
      "label": "Puducherry",
      "value": "PY"
    },
    {
      "label": "Rajasthan",
      "value": "RJ"
    },
    {
      "label": "Sikkim",
      "value": "SK"
    },
    {
      "label": "Tamil Nadu",
      "value": "TN"
    },
    {
      "label": "Tripura",
      "value": "TR"
    },
    {
      "label": "Telangana",
      "value": "TS"
    },
    {
      "label": "Uttarakhand",
      "value": "UK"
    },
    {
      "label": "Uttar Pradesh",
      "value": "UP"
    },
    {
      "label": "West Bengal",
      "value": "WB"
    }
  ],
  "ID": [
    {
      "label": "Aceh",
      "value": "AC"
    },
    {
      "label": "Bali",
      "value": "BA"
    },
    {
      "label": "Bangka Belitung",
      "value": "BB"
    },
    {
      "label": "Bengkulu",
      "value": "BE"
    },
    {
      "label": "Banten",
      "value": "BT"
    },
    {
      "label": "Gorontalo",
      "value": "GO"
    },
    {
      "label": "Jambi",
      "value": "JA"
    },
    {
      "label": "Jawa Barat",
      "value": "JB"
    },
    {
      "label": "Jawa Timur",
      "value": "JI"
    },
    {
      "label": "Jakarta",
      "value": "JK"
    },
    {
      "label": "Jawa Tengah",
      "value": "JT"
    },
    {
      "label": "Kalimantan Barat",
      "value": "KB"
    },
    {
      "label": "Kalimantan Timur",
      "value": "KI"
    },
    {
      "label": "Kepulauan Riau",
      "value": "KR"
    },
    {
      "label": "Kalimantan Selatan",
      "value": "KS"
    },
    {
      "label": "Kalimantan Tengah",
      "value": "KT"
    },
    {
      "label": "Kalimantan Utara",
      "value": "KU"
    },
    {
      "label": "Lampung",
      "value": "LA"
    },
    {
      "label": "Maluku",
      "value": "MA"
    },
    {
      "label": "Maluku Utara",
      "value": "MU"
    },
    {
      "label": "Nusa Tenggara Barat",
      "value": "NB"
    },
    {
      "label": "Nusa Tenggara Timur",
      "value": "NT"
    },
    {
      "label": "Papua",
      "value": "PA"
    },
    {
      "label": "Papua Barat",
      "value": "PB"
    },
    {
      "label": "Riau",
      "value": "RI"
    },
    {
      "label": "Sulawesi Utara",
      "value": "SA"
    },
    {
      "label": "West Sumatra",
      "value": "SB"
    },
    {
      "label": "Sulawesi Tenggara",
      "value": "SG"
    },
    {
      "label": "Sulawesi Selatan",
      "value": "SN"
    },
    {
      "label": "Sulawesi Barat",
      "value": "SR"
    },
    {
      "label": "South Sumatra",
      "value": "SS"
    },
    {
      "label": "Sulawesi Tengah",
      "value": "ST"
    },
    {
      "label": "North Sumatra",
      "value": "SU"
    },
    {
      "label": "Yogyakarta",
      "value": "YO"
    }
  ],
  "IQ": [],
  "IE": [
    {
      "label": "Clare",
      "value": "CE"
    },
    {
      "label": "Cavan",
      "value": "CN"
    },
    {
      "label": "Cork",
      "value": "CO"
    },
    {
      "label": "Carlow",
      "value": "CW"
    },
    {
      "label": "Dublin",
      "value": "D"
    },
    {
      "label": "Donegal",
      "value": "DL"
    },
    {
      "label": "Galway",
      "value": "G"
    },
    {
      "label": "Kildare",
      "value": "KE"
    },
    {
      "label": "Kilkenny",
      "value": "KK"
    },
    {
      "label": "Kerry",
      "value": "KY"
    },
    {
      "label": "Longford",
      "value": "LD"
    },
    {
      "label": "Louth",
      "value": "LH"
    },
    {
      "label": "Limerick",
      "value": "LK"
    },
    {
      "label": "Leitrim",
      "value": "LM"
    },
    {
      "label": "Laois",
      "value": "LS"
    },
    {
      "label": "Meath",
      "value": "MH"
    },
    {
      "label": "Monaghan",
      "value": "MN"
    },
    {
      "label": "Mayo",
      "value": "MO"
    },
    {
      "label": "Offaly",
      "value": "OY"
    },
    {
      "label": "Roscommon",
      "value": "RN"
    },
    {
      "label": "Sligo",
      "value": "SO"
    },
    {
      "label": "Tipperary",
      "value": "TA"
    },
    {
      "label": "Waterford",
      "value": "WD"
    },
    {
      "label": "Westmeath",
      "value": "WH"
    },
    {
      "label": "Wicklow",
      "value": "WW"
    },
    {
      "label": "Wexford",
      "value": "WX"
    }
  ],
  "IM": [],
  "IL": [],
  "IT": [
    {
      "label": "Agrigento",
      "value": "AG"
    },
    {
      "label": "Alessandria",
      "value": "AL"
    },
    {
      "label": "Ancona",
      "value": "AN"
    },
    {
      "label": "Aosta",
      "value": "AO"
    },
    {
      "label": "Ascoli Piceno",
      "value": "AP"
    },
    {
      "label": "L'Aquila",
      "value": "AQ"
    },
    {
      "label": "Arezzo",
      "value": "AR"
    },
    {
      "label": "Asti",
      "value": "AT"
    },
    {
      "label": "Avellino",
      "value": "AV"
    },
    {
      "label": "Bari",
      "value": "BA"
    },
    {
      "label": "Bergamo",
      "value": "BG"
    },
    {
      "label": "Biella",
      "value": "BI"
    },
    {
      "label": "Belluno",
      "value": "BL"
    },
    {
      "label": "Benevento",
      "value": "BN"
    },
    {
      "label": "Bologna",
      "value": "BO"
    },
    {
      "label": "Brindisi",
      "value": "BR"
    },
    {
      "label": "Brescia",
      "value": "BS"
    },
    {
      "label": "Barletta-Andria-Trani",
      "value": "BT"
    },
    {
      "label": "Bolzano",
      "value": "BZ"
    },
    {
      "label": "Cagliari",
      "value": "CA"
    },
    {
      "label": "Campobasso",
      "value": "CB"
    },
    {
      "label": "Caserta",
      "value": "CE"
    },
    {
      "label": "Chieti",
      "value": "CH"
    },
    {
      "label": "Carbonia-Iglesias",
      "value": "CI"
    },
    {
      "label": "Caltanissetta",
      "value": "CL"
    },
    {
      "label": "Cuneo",
      "value": "CN"
    },
    {
      "label": "Como",
      "value": "CO"
    },
    {
      "label": "Cremona",
      "value": "CR"
    },
    {
      "label": "Cosenza",
      "value": "CS"
    },
    {
      "label": "Catania",
      "value": "CT"
    },
    {
      "label": "Catanzaro",
      "value": "CZ"
    },
    {
      "label": "Enna",
      "value": "EN"
    },
    {
      "label": "Forlì-Cesena",
      "value": "FC"
    },
    {
      "label": "Ferrara",
      "value": "FE"
    },
    {
      "label": "Foggia",
      "value": "FG"
    },
    {
      "label": "Firenze",
      "value": "FI"
    },
    {
      "label": "Fermo",
      "value": "FM"
    },
    {
      "label": "Frosinone",
      "value": "FR"
    },
    {
      "label": "Genova",
      "value": "GE"
    },
    {
      "label": "Gorizia",
      "value": "GO"
    },
    {
      "label": "Grosseto",
      "value": "GR"
    },
    {
      "label": "Imperia",
      "value": "IM"
    },
    {
      "label": "Isernia",
      "value": "IS"
    },
    {
      "label": "Crotone",
      "value": "KR"
    },
    {
      "label": "Lecco",
      "value": "LC"
    },
    {
      "label": "Lecce",
      "value": "LE"
    },
    {
      "label": "Livorno",
      "value": "LI"
    },
    {
      "label": "Lodi",
      "value": "LO"
    },
    {
      "label": "Latina",
      "value": "LT"
    },
    {
      "label": "Lucca",
      "value": "LU"
    },
    {
      "label": "Monza e Brianza",
      "value": "MB"
    },
    {
      "label": "Macerata",
      "value": "MC"
    },
    {
      "label": "Messina",
      "value": "ME"
    },
    {
      "label": "Milano",
      "value": "MI"
    },
    {
      "label": "Mantova",
      "value": "MN"
    },
    {
      "label": "Modena",
      "value": "MO"
    },
    {
      "label": "Massa-Carrara",
      "value": "MS"
    },
    {
      "label": "Matera",
      "value": "MT"
    },
    {
      "label": "Napoli",
      "value": "NA"
    },
    {
      "label": "Novara",
      "value": "NO"
    },
    {
      "label": "Nuoro",
      "value": "NU"
    },
    {
      "label": "Ogliastra",
      "value": "OG"
    },
    {
      "label": "Oristano",
      "value": "OR"
    },
    {
      "label": "Olbia-Tempio",
      "value": "OT"
    },
    {
      "label": "Palermo",
      "value": "PA"
    },
    {
      "label": "Piacenza",
      "value": "PC"
    },
    {
      "label": "Padova",
      "value": "PD"
    },
    {
      "label": "Pescara",
      "value": "PE"
    },
    {
      "label": "Perugia",
      "value": "PG"
    },
    {
      "label": "Pisa",
      "value": "PI"
    },
    {
      "label": "Pordenone",
      "value": "PN"
    },
    {
      "label": "Prato",
      "value": "PO"
    },
    {
      "label": "Parma",
      "value": "PR"
    },
    {
      "label": "Pistoia",
      "value": "PT"
    },
    {
      "label": "Pesaro e Urbino",
      "value": "PU"
    },
    {
      "label": "Pavia",
      "value": "PV"
    },
    {
      "label": "Potenza",
      "value": "PZ"
    },
    {
      "label": "Ravenna",
      "value": "RA"
    },
    {
      "label": "Reggio Calabria",
      "value": "RC"
    },
    {
      "label": "Reggio Emilia",
      "value": "RE"
    },
    {
      "label": "Ragusa",
      "value": "RG"
    },
    {
      "label": "Rieti",
      "value": "RI"
    },
    {
      "label": "Roma",
      "value": "RM"
    },
    {
      "label": "Rimini",
      "value": "RN"
    },
    {
      "label": "Rovigo",
      "value": "RO"
    },
    {
      "label": "Salerno",
      "value": "SA"
    },
    {
      "label": "Siena",
      "value": "SI"
    },
    {
      "label": "Sondrio",
      "value": "SO"
    },
    {
      "label": "La Spezia",
      "value": "SP"
    },
    {
      "label": "Siracusa",
      "value": "SR"
    },
    {
      "label": "Sassari",
      "value": "SS"
    },
    {
      "label": "Savona",
      "value": "SV"
    },
    {
      "label": "Taranto",
      "value": "TA"
    },
    {
      "label": "Teramo",
      "value": "TE"
    },
    {
      "label": "Trento",
      "value": "TN"
    },
    {
      "label": "Torino",
      "value": "TO"
    },
    {
      "label": "Trapani",
      "value": "TP"
    },
    {
      "label": "Terni",
      "value": "TR"
    },
    {
      "label": "Trieste",
      "value": "TS"
    },
    {
      "label": "Treviso",
      "value": "TV"
    },
    {
      "label": "Udine",
      "value": "UD"
    },
    {
      "label": "Varese",
      "value": "VA"
    },
    {
      "label": "Verbano-Cusio-Ossola",
      "value": "VB"
    },
    {
      "label": "Vercelli",
      "value": "VC"
    },
    {
      "label": "Venezia",
      "value": "VE"
    },
    {
      "label": "Vicenza",
      "value": "VI"
    },
    {
      "label": "Verona",
      "value": "VR"
    },
    {
      "label": "Medio Campidano",
      "value": "VS"
    },
    {
      "label": "Viterbo",
      "value": "VT"
    },
    {
      "label": "Vibo Valentia",
      "value": "VV"
    }
  ],
  "JM": [],
  "JP": [
    {
      "label": "Hokkaidō",
      "value": "JP-01"
    },
    {
      "label": "Aomori",
      "value": "JP-02"
    },
    {
      "label": "Iwate",
      "value": "JP-03"
    },
    {
      "label": "Miyagi",
      "value": "JP-04"
    },
    {
      "label": "Akita",
      "value": "JP-05"
    },
    {
      "label": "Yamagata",
      "value": "JP-06"
    },
    {
      "label": "Fukushima",
      "value": "JP-07"
    },
    {
      "label": "Ibaraki",
      "value": "JP-08"
    },
    {
      "label": "Tochigi",
      "value": "JP-09"
    },
    {
      "label": "Gunma",
      "value": "JP-10"
    },
    {
      "label": "Saitama",
      "value": "JP-11"
    },
    {
      "label": "Chiba",
      "value": "JP-12"
    },
    {
      "label": "Tōkyō",
      "value": "JP-13"
    },
    {
      "label": "Kanagawa",
      "value": "JP-14"
    },
    {
      "label": "Niigata",
      "value": "JP-15"
    },
    {
      "label": "Toyama",
      "value": "JP-16"
    },
    {
      "label": "Ishikawa",
      "value": "JP-17"
    },
    {
      "label": "Fukui",
      "value": "JP-18"
    },
    {
      "label": "Yamanashi",
      "value": "JP-19"
    },
    {
      "label": "Nagano",
      "value": "JP-20"
    },
    {
      "label": "Gifu",
      "value": "JP-21"
    },
    {
      "label": "Shizuoka",
      "value": "JP-22"
    },
    {
      "label": "Aichi",
      "value": "JP-23"
    },
    {
      "label": "Mie",
      "value": "JP-24"
    },
    {
      "label": "Shiga",
      "value": "JP-25"
    },
    {
      "label": "Kyōto",
      "value": "JP-26"
    },
    {
      "label": "Ōsaka",
      "value": "JP-27"
    },
    {
      "label": "Hyōgo",
      "value": "JP-28"
    },
    {
      "label": "Nara",
      "value": "JP-29"
    },
    {
      "label": "Wakayama",
      "value": "JP-30"
    },
    {
      "label": "Tottori",
      "value": "JP-31"
    },
    {
      "label": "Shimane",
      "value": "JP-32"
    },
    {
      "label": "Okayama",
      "value": "JP-33"
    },
    {
      "label": "Hiroshima",
      "value": "JP-34"
    },
    {
      "label": "Yamaguchi",
      "value": "JP-35"
    },
    {
      "label": "Tokushima",
      "value": "JP-36"
    },
    {
      "label": "Kagawa",
      "value": "JP-37"
    },
    {
      "label": "Ehime",
      "value": "JP-38"
    },
    {
      "label": "Kōchi",
      "value": "JP-39"
    },
    {
      "label": "Fukuoka",
      "value": "JP-40"
    },
    {
      "label": "Saga",
      "value": "JP-41"
    },
    {
      "label": "Nagasaki",
      "value": "JP-42"
    },
    {
      "label": "Kumamoto",
      "value": "JP-43"
    },
    {
      "label": "Ōita",
      "value": "JP-44"
    },
    {
      "label": "Miyazaki",
      "value": "JP-45"
    },
    {
      "label": "Kagoshima",
      "value": "JP-46"
    },
    {
      "label": "Okinawa",
      "value": "JP-47"
    }
  ],
  "JE": [],
  "JO": [],
  "KZ": [],
  "KE": [],
  "KI": [],
  "XK": [],
  "KW": [
    {
      "label": "Al Ahmadi",
      "value": "KW-AH"
    },
    {
      "label": "Al Farwaniyah",
      "value": "KW-FA"
    },
    {
      "label": "Hawalli",
      "value": "KW-HA"
    },
    {
      "label": "Al Jahra",
      "value": "KW-JA"
    },
    {
      "label": "Al Asimah",
      "value": "KW-KU"
    },
    {
      "label": "Mubarak Al-Kabeer",
      "value": "KW-MU"
    }
  ],
  "KG": [],
  "LA": [],
  "LV": [],
  "LB": [],
  "LS": [],
  "LR": [],
  "LY": [],
  "LI": [],
  "LT": [],
  "LU": [],
  "MO": [],
  "MG": [],
  "MW": [],
  "MY": [
    {
      "label": "Johor",
      "value": "JHR"
    },
    {
      "label": "Kedah",
      "value": "KDH"
    },
    {
      "label": "Kelantan",
      "value": "KTN"
    },
    {
      "label": "Kuala Lumpur",
      "value": "KUL"
    },
    {
      "label": "Labuan",
      "value": "LBN"
    },
    {
      "label": "Melaka",
      "value": "MLK"
    },
    {
      "label": "Negeri Sembilan",
      "value": "NSN"
    },
    {
      "label": "Pahang",
      "value": "PHG"
    },
    {
      "label": "Putrajaya",
      "value": "PJY"
    },
    {
      "label": "Perlis",
      "value": "PLS"
    },
    {
      "label": "Penang",
      "value": "PNG"
    },
    {
      "label": "Perak",
      "value": "PRK"
    },
    {
      "label": "Sabah",
      "value": "SBH"
    },
    {
      "label": "Selangor",
      "value": "SGR"
    },
    {
      "label": "Sarawak",
      "value": "SWK"
    },
    {
      "label": "Terengganu",
      "value": "TRG"
    }
  ],
  "MV": [],
  "ML": [],
  "MT": [],
  "MQ": [],
  "MR": [],
  "MU": [],
  "YT": [],
  "MX": [
    {
      "label": "Aguascalientes",
      "value": "AGS"
    },
    {
      "label": "Baja California",
      "value": "BC"
    },
    {
      "label": "Baja California Sur",
      "value": "BCS"
    },
    {
      "label": "Campeche",
      "value": "CAMP"
    },
    {
      "label": "Chihuahua",
      "value": "CHIH"
    },
    {
      "label": "Chiapas",
      "value": "CHIS"
    },
    {
      "label": "Coahuila",
      "value": "COAH"
    },
    {
      "label": "Colima",
      "value": "COL"
    },
    {
      "label": "Ciudad de México",
      "value": "DF"
    },
    {
      "label": "Durango",
      "value": "DGO"
    },
    {
      "label": "Guerrero",
      "value": "GRO"
    },
    {
      "label": "Guanajuato",
      "value": "GTO"
    },
    {
      "label": "Hidalgo",
      "value": "HGO"
    },
    {
      "label": "Jalisco",
      "value": "JAL"
    },
    {
      "label": "México",
      "value": "MEX"
    },
    {
      "label": "Michoacán",
      "value": "MICH"
    },
    {
      "label": "Morelos",
      "value": "MOR"
    },
    {
      "label": "Nayarit",
      "value": "NAY"
    },
    {
      "label": "Nuevo León",
      "value": "NL"
    },
    {
      "label": "Oaxaca",
      "value": "OAX"
    },
    {
      "label": "Puebla",
      "value": "PUE"
    },
    {
      "label": "Quintana Roo",
      "value": "Q ROO"
    },
    {
      "label": "Querétaro",
      "value": "QRO"
    },
    {
      "label": "Sinaloa",
      "value": "SIN"
    },
    {
      "label": "San Luis Potosí",
      "value": "SLP"
    },
    {
      "label": "Sonora",
      "value": "SON"
    },
    {
      "label": "Tabasco",
      "value": "TAB"
    },
    {
      "label": "Tamaulipas",
      "value": "TAMPS"
    },
    {
      "label": "Tlaxcala",
      "value": "TLAX"
    },
    {
      "label": "Veracruz",
      "value": "VER"
    },
    {
      "label": "Yucatán",
      "value": "YUC"
    },
    {
      "label": "Zacatecas",
      "value": "ZAC"
    }
  ],
  "MD": [],
  "MC": [],
  "MN": [],
  "ME": [],
  "MS": [],
  "MA": [],
  "MZ": [],
  "MM": [],
  "NA": [],
  "NR": [],
  "NP": [],
  "NL": [],
  "NC": [],
  "NZ": [
    {
      "label": "Auckland",
      "value": "AUK"
    },
    {
      "label": "Bay of Plenty",
      "value": "BOP"
    },
    {
      "label": "Canterbury",
      "value": "CAN"
    },
    {
      "label": "Chatham Islands",
      "value": "CIT"
    },
    {
      "label": "Gisborne",
      "value": "GIS"
    },
    {
      "label": "Hawke's Bay",
      "value": "HKB"
    },
    {
      "label": "Marlborough",
      "value": "MBH"
    },
    {
      "label": "Manawatu-Wanganui",
      "value": "MWT"
    },
    {
      "label": "Nelson",
      "value": "NSN"
    },
    {
      "label": "Northland",
      "value": "NTL"
    },
    {
      "label": "Otago",
      "value": "OTA"
    },
    {
      "label": "Southland",
      "value": "STL"
    },
    {
      "label": "Tasman",
      "value": "TAS"
    },
    {
      "label": "Taranaki",
      "value": "TKI"
    },
    {
      "label": "Wellington",
      "value": "WGN"
    },
    {
      "label": "Waikato",
      "value": "WKO"
    },
    {
      "label": "West Coast",
      "value": "WTC"
    }
  ],
  "NI": [],
  "NE": [],
  "NG": [
    {
      "label": "Abia",
      "value": "AB"
    },
    {
      "label": "Adamawa",
      "value": "AD"
    },
    {
      "label": "Akwa Ibom",
      "value": "AK"
    },
    {
      "label": "Anambra",
      "value": "AN"
    },
    {
      "label": "Bauchi",
      "value": "BA"
    },
    {
      "label": "Benue",
      "value": "BE"
    },
    {
      "label": "Borno",
      "value": "BO"
    },
    {
      "label": "Bayelsa",
      "value": "BY"
    },
    {
      "label": "Cross River",
      "value": "CR"
    },
    {
      "label": "Delta",
      "value": "DE"
    },
    {
      "label": "Ebonyi",
      "value": "EB"
    },
    {
      "label": "Edo",
      "value": "ED"
    },
    {
      "label": "Ekiti",
      "value": "EK"
    },
    {
      "label": "Enugu",
      "value": "EN"
    },
    {
      "label": "Abuja Federal Capital Territory",
      "value": "FC"
    },
    {
      "label": "Gombe",
      "value": "GO"
    },
    {
      "label": "Imo",
      "value": "IM"
    },
    {
      "label": "Jigawa",
      "value": "JI"
    },
    {
      "label": "Kaduna",
      "value": "KD"
    },
    {
      "label": "Kebbi",
      "value": "KE"
    },
    {
      "label": "Kano",
      "value": "KN"
    },
    {
      "label": "Kogi",
      "value": "KO"
    },
    {
      "label": "Katsina",
      "value": "KT"
    },
    {
      "label": "Kwara",
      "value": "KW"
    },
    {
      "label": "Lagos",
      "value": "LA"
    },
    {
      "label": "Nasarawa",
      "value": "NA"
    },
    {
      "label": "Niger",
      "value": "NI"
    },
    {
      "label": "Ogun",
      "value": "OG"
    },
    {
      "label": "Ondo",
      "value": "ON"
    },
    {
      "label": "Osun",
      "value": "OS"
    },
    {
      "label": "Oyo",
      "value": "OY"
    },
    {
      "label": "Plateau",
      "value": "PL"
    },
    {
      "label": "Rivers",
      "value": "RI"
    },
    {
      "label": "Sokoto",
      "value": "SO"
    },
    {
      "label": "Taraba",
      "value": "TA"
    },
    {
      "label": "Yobe",
      "value": "YO"
    },
    {
      "label": "Zamfara",
      "value": "ZA"
    }
  ],
  "NU": [],
  "NF": [],
  "MK": [],
  "NO": [],
  "OM": [],
  "PK": [],
  "PS": [],
  "PA": [
    {
      "label": "Bocas del Toro",
      "value": "PA-1"
    },
    {
      "label": "Panamá Oeste",
      "value": "PA-10"
    },
    {
      "label": "Coclé",
      "value": "PA-2"
    },
    {
      "label": "Colón",
      "value": "PA-3"
    },
    {
      "label": "Chiriquí",
      "value": "PA-4"
    },
    {
      "label": "Darién",
      "value": "PA-5"
    },
    {
      "label": "Herrera",
      "value": "PA-6"
    },
    {
      "label": "Los Santos",
      "value": "PA-7"
    },
    {
      "label": "Panamá",
      "value": "PA-8"
    },
    {
      "label": "Veraguas",
      "value": "PA-9"
    },
    {
      "label": "Emberá",
      "value": "PA-EM"
    },
    {
      "label": "Kuna Yala",
      "value": "PA-KY"
    },
    {
      "label": "Ngöbe-Buglé",
      "value": "PA-NB"
    }
  ],
  "PG": [],
  "PY": [],
  "PE": [
    {
      "label": "Amazonas",
      "value": "PE-AMA"
    },
    {
      "label": "Áncash",
      "value": "PE-ANC"
    },
    {
      "label": "Apurímac",
      "value": "PE-APU"
    },
    {
      "label": "Arequipa",
      "value": "PE-ARE"
    },
    {
      "label": "Ayacucho",
      "value": "PE-AYA"
    },
    {
      "label": "Cajamarca",
      "value": "PE-CAJ"
    },
    {
      "label": "Callao",
      "value": "PE-CAL"
    },
    {
      "label": "Cuzco",
      "value": "PE-CUS"
    },
    {
      "label": "Huánuco",
      "value": "PE-HUC"
    },
    {
      "label": "Huancavelica",
      "value": "PE-HUV"
    },
    {
      "label": "Ica",
      "value": "PE-ICA"
    },
    {
      "label": "Junín",
      "value": "PE-JUN"
    },
    {
      "label": "La Libertad",
      "value": "PE-LAL"
    },
    {
      "label": "Lambayeque",
      "value": "PE-LAM"
    },
    {
      "label": "Lima (departamento)",
      "value": "PE-LIM"
    },
    {
      "label": "Lima (provincia)",
      "value": "PE-LMA"
    },
    {
      "label": "Loreto",
      "value": "PE-LOR"
    },
    {
      "label": "Madre de Dios",
      "value": "PE-MDD"
    },
    {
      "label": "Moquegua",
      "value": "PE-MOQ"
    },
    {
      "label": "Pasco",
      "value": "PE-PAS"
    },
    {
      "label": "Piura",
      "value": "PE-PIU"
    },
    {
      "label": "Puno",
      "value": "PE-PUN"
    },
    {
      "label": "San Martín",
      "value": "PE-SAM"
    },
    {
      "label": "Tacna",
      "value": "PE-TAC"
    },
    {
      "label": "Tumbes",
      "value": "PE-TUM"
    },
    {
      "label": "Ucayali",
      "value": "PE-UCA"
    }
  ],
  "PH": [
    {
      "label": "Metro Manila",
      "value": "PH-00"
    },
    {
      "label": "Abra",
      "value": "PH-ABR"
    },
    {
      "label": "Agusan del Norte",
      "value": "PH-AGN"
    },
    {
      "label": "Agusan del Sur",
      "value": "PH-AGS"
    },
    {
      "label": "Aklan",
      "value": "PH-AKL"
    },
    {
      "label": "Albay",
      "value": "PH-ALB"
    },
    {
      "label": "Antique",
      "value": "PH-ANT"
    },
    {
      "label": "Apayao",
      "value": "PH-APA"
    },
    {
      "label": "Aurora",
      "value": "PH-AUR"
    },
    {
      "label": "Bataan",
      "value": "PH-BAN"
    },
    {
      "label": "Basilan",
      "value": "PH-BAS"
    },
    {
      "label": "Benguet",
      "value": "PH-BEN"
    },
    {
      "label": "Biliran",
      "value": "PH-BIL"
    },
    {
      "label": "Bohol",
      "value": "PH-BOH"
    },
    {
      "label": "Batangas",
      "value": "PH-BTG"
    },
    {
      "label": "Batanes",
      "value": "PH-BTN"
    },
    {
      "label": "Bukidnon",
      "value": "PH-BUK"
    },
    {
      "label": "Bulacan",
      "value": "PH-BUL"
    },
    {
      "label": "Cagayan",
      "value": "PH-CAG"
    },
    {
      "label": "Camiguin",
      "value": "PH-CAM"
    },
    {
      "label": "Camarines Norte",
      "value": "PH-CAN"
    },
    {
      "label": "Capiz",
      "value": "PH-CAP"
    },
    {
      "label": "Camarines Sur",
      "value": "PH-CAS"
    },
    {
      "label": "Catanduanes",
      "value": "PH-CAT"
    },
    {
      "label": "Cavite",
      "value": "PH-CAV"
    },
    {
      "label": "Cebu",
      "value": "PH-CEB"
    },
    {
      "label": "Davao de Oro",
      "value": "PH-COM"
    },
    {
      "label": "Davao Oriental",
      "value": "PH-DAO"
    },
    {
      "label": "Davao del Sur",
      "value": "PH-DAS"
    },
    {
      "label": "Davao del Norte",
      "value": "PH-DAV"
    },
    {
      "label": "Dinagat Islands",
      "value": "PH-DIN"
    },
    {
      "label": "Davao Occidental",
      "value": "PH-DVO"
    },
    {
      "label": "Eastern Samar",
      "value": "PH-EAS"
    },
    {
      "label": "Guimaras",
      "value": "PH-GUI"
    },
    {
      "label": "Ifugao",
      "value": "PH-IFU"
    },
    {
      "label": "Iloilo",
      "value": "PH-ILI"
    },
    {
      "label": "Ilocos Norte",
      "value": "PH-ILN"
    },
    {
      "label": "Ilocos Sur",
      "value": "PH-ILS"
    },
    {
      "label": "Isabela",
      "value": "PH-ISA"
    },
    {
      "label": "Kalinga",
      "value": "PH-KAL"
    },
    {
      "label": "Laguna",
      "value": "PH-LAG"
    },
    {
      "label": "Lanao del Norte",
      "value": "PH-LAN"
    },
    {
      "label": "Lanao del Sur",
      "value": "PH-LAS"
    },
    {
      "label": "Leyte",
      "value": "PH-LEY"
    },
    {
      "label": "La Union",
      "value": "PH-LUN"
    },
    {
      "label": "Marinduque",
      "value": "PH-MAD"
    },
    {
      "label": "Maguindanao",
      "value": "PH-MAG"
    },
    {
      "label": "Masbate",
      "value": "PH-MAS"
    },
    {
      "label": "Occidental Mindoro",
      "value": "PH-MDC"
    },
    {
      "label": "Oriental Mindoro",
      "value": "PH-MDR"
    },
    {
      "label": "Mountain Province",
      "value": "PH-MOU"
    },
    {
      "label": "Misamis Occidental",
      "value": "PH-MSC"
    },
    {
      "label": "Misamis Oriental",
      "value": "PH-MSR"
    },
    {
      "label": "Cotabato",
      "value": "PH-NCO"
    },
    {
      "label": "Negros Occidental",
      "value": "PH-NEC"
    },
    {
      "label": "Negros Oriental",
      "value": "PH-NER"
    },
    {
      "label": "Northern Samar",
      "value": "PH-NSA"
    },
    {
      "label": "Nueva Ecija",
      "value": "PH-NUE"
    },
    {
      "label": "Nueva Vizcaya",
      "value": "PH-NUV"
    },
    {
      "label": "Pampanga",
      "value": "PH-PAM"
    },
    {
      "label": "Pangasinan",
      "value": "PH-PAN"
    },
    {
      "label": "Palawan",
      "value": "PH-PLW"
    },
    {
      "label": "Quezon",
      "value": "PH-QUE"
    },
    {
      "label": "Quirino",
      "value": "PH-QUI"
    },
    {
      "label": "Rizal",
      "value": "PH-RIZ"
    },
    {
      "label": "Romblon",
      "value": "PH-ROM"
    },
    {
      "label": "Sarangani",
      "value": "PH-SAR"
    },
    {
      "label": "South Cotabato",
      "value": "PH-SCO"
    },
    {
      "label": "Siquijor",
      "value": "PH-SIG"
    },
    {
      "label": "Southern Leyte",
      "value": "PH-SLE"
    },
    {
      "label": "Sulu",
      "value": "PH-SLU"
    },
    {
      "label": "Sorsogon",
      "value": "PH-SOR"
    },
    {
      "label": "Sultan Kudarat",
      "value": "PH-SUK"
    },
    {
      "label": "Surigao del Norte",
      "value": "PH-SUN"
    },
    {
      "label": "Surigao del Sur",
      "value": "PH-SUR"
    },
    {
      "label": "Tarlac",
      "value": "PH-TAR"
    },
    {
      "label": "Tawi-Tawi",
      "value": "PH-TAW"
    },
    {
      "label": "Samar",
      "value": "PH-WSA"
    },
    {
      "label": "Zamboanga del Norte",
      "value": "PH-ZAN"
    },
    {
      "label": "Zamboanga del Sur",
      "value": "PH-ZAS"
    },
    {
      "label": "Zambales",
      "value": "PH-ZMB"
    },
    {
      "label": "Zamboanga Sibugay",
      "value": "PH-ZSI"
    }
  ],
  "PN": [],
  "PL": [],
  "PT": [
    {
      "label": "Aveiro",
      "value": "PT-01"
    },
    {
      "label": "Beja",
      "value": "PT-02"
    },
    {
      "label": "Braga",
      "value": "PT-03"
    },
    {
      "label": "Bragança",
      "value": "PT-04"
    },
    {
      "label": "Castelo Branco",
      "value": "PT-05"
    },
    {
      "label": "Coimbra",
      "value": "PT-06"
    },
    {
      "label": "Évora",
      "value": "PT-07"
    },
    {
      "label": "Faro",
      "value": "PT-08"
    },
    {
      "label": "Guarda",
      "value": "PT-09"
    },
    {
      "label": "Leiria",
      "value": "PT-10"
    },
    {
      "label": "Lisboa",
      "value": "PT-11"
    },
    {
      "label": "Portalegre",
      "value": "PT-12"
    },
    {
      "label": "Porto",
      "value": "PT-13"
    },
    {
      "label": "Santarém",
      "value": "PT-14"
    },
    {
      "label": "Setúbal",
      "value": "PT-15"
    },
    {
      "label": "Viana do Castelo",
      "value": "PT-16"
    },
    {
      "label": "Vila Real",
      "value": "PT-17"
    },
    {
      "label": "Viseu",
      "value": "PT-18"
    },
    {
      "label": "Açores",
      "value": "PT-20"
    },
    {
      "label": "Madeira",
      "value": "PT-30"
    }
  ],
  "QA": [],
  "CM": [],
  "RE": [],
  "RO": [
    {
      "label": "Alba",
      "value": "AB"
    },
    {
      "label": "Argeș",
      "value": "AG"
    },
    {
      "label": "Arad",
      "value": "AR"
    },
    {
      "label": "București",
      "value": "B"
    },
    {
      "label": "Bacău",
      "value": "BC"
    },
    {
      "label": "Bihor",
      "value": "BH"
    },
    {
      "label": "Bistrița-Năsăud",
      "value": "BN"
    },
    {
      "label": "Brăila",
      "value": "BR"
    },
    {
      "label": "Botoșani",
      "value": "BT"
    },
    {
      "label": "Brașov",
      "value": "BV"
    },
    {
      "label": "Buzău",
      "value": "BZ"
    },
    {
      "label": "Cluj",
      "value": "CJ"
    },
    {
      "label": "Călărași",
      "value": "CL"
    },
    {
      "label": "Caraș-Severin",
      "value": "CS"
    },
    {
      "label": "Constanța",
      "value": "CT"
    },
    {
      "label": "Covasna",
      "value": "CV"
    },
    {
      "label": "Dâmbovița",
      "value": "DB"
    },
    {
      "label": "Dolj",
      "value": "DJ"
    },
    {
      "label": "Gorj",
      "value": "GJ"
    },
    {
      "label": "Galați",
      "value": "GL"
    },
    {
      "label": "Giurgiu",
      "value": "GR"
    },
    {
      "label": "Hunedoara",
      "value": "HD"
    },
    {
      "label": "Harghita",
      "value": "HR"
    },
    {
      "label": "Ilfov",
      "value": "IF"
    },
    {
      "label": "Ialomița",
      "value": "IL"
    },
    {
      "label": "Iași",
      "value": "IS"
    },
    {
      "label": "Mehedinți",
      "value": "MH"
    },
    {
      "label": "Maramureș",
      "value": "MM"
    },
    {
      "label": "Mureș",
      "value": "MS"
    },
    {
      "label": "Neamț",
      "value": "NT"
    },
    {
      "label": "Olt",
      "value": "OT"
    },
    {
      "label": "Prahova",
      "value": "PH"
    },
    {
      "label": "Sibiu",
      "value": "SB"
    },
    {
      "label": "Sălaj",
      "value": "SJ"
    },
    {
      "label": "Satu Mare",
      "value": "SM"
    },
    {
      "label": "Suceava",
      "value": "SV"
    },
    {
      "label": "Tulcea",
      "value": "TL"
    },
    {
      "label": "Timiș",
      "value": "TM"
    },
    {
      "label": "Teleorman",
      "value": "TR"
    },
    {
      "label": "Vâlcea",
      "value": "VL"
    },
    {
      "label": "Vrancea",
      "value": "VN"
    },
    {
      "label": "Vaslui",
      "value": "VS"
    }
  ],
  "RU": [
    {
      "label": "Republic of Adygeya",
      "value": "AD"
    },
    {
      "label": "Altai Republic",
      "value": "AL"
    },
    {
      "label": "Altai Krai",
      "value": "ALT"
    },
    {
      "label": "Amur Oblast",
      "value": "AMU"
    },
    {
      "label": "Arkhangelsk Oblast",
      "value": "ARK"
    },
    {
      "label": "Astrakhan Oblast",
      "value": "AST"
    },
    {
      "label": "Republic of Bashkortostan",
      "value": "BA"
    },
    {
      "label": "Belgorod Oblast",
      "value": "BEL"
    },
    {
      "label": "Bryansk Oblast",
      "value": "BRY"
    },
    {
      "label": "Republic of Buryatia",
      "value": "BU"
    },
    {
      "label": "Chechen Republic",
      "value": "CE"
    },
    {
      "label": "Chelyabinsk Oblast",
      "value": "CHE"
    },
    {
      "label": "Chukotka Autonomous Okrug",
      "value": "CHU"
    },
    {
      "label": "Chuvash Republic",
      "value": "CU"
    },
    {
      "label": "Republic of Dagestan",
      "value": "DA"
    },
    {
      "label": "Republic of Ingushetia",
      "value": "IN"
    },
    {
      "label": "Irkutsk Oblast",
      "value": "IRK"
    },
    {
      "label": "Ivanovo Oblast",
      "value": "IVA"
    },
    {
      "label": "Kamchatka Krai",
      "value": "KAM"
    },
    {
      "label": "Kabardino-Balkarian Republic",
      "value": "KB"
    },
    {
      "label": "Karachay–Cherkess Republic",
      "value": "KC"
    },
    {
      "label": "Krasnodar Krai",
      "value": "KDA"
    },
    {
      "label": "Kemerovo Oblast",
      "value": "KEM"
    },
    {
      "label": "Kaliningrad Oblast",
      "value": "KGD"
    },
    {
      "label": "Kurgan Oblast",
      "value": "KGN"
    },
    {
      "label": "Khabarovsk Krai",
      "value": "KHA"
    },
    {
      "label": "Khanty-Mansi Autonomous Okrug",
      "value": "KHM"
    },
    {
      "label": "Kirov Oblast",
      "value": "KIR"
    },
    {
      "label": "Republic of Khakassia",
      "value": "KK"
    },
    {
      "label": "Republic of Kalmykia",
      "value": "KL"
    },
    {
      "label": "Kaluga Oblast",
      "value": "KLU"
    },
    {
      "label": "Komi Republic",
      "value": "KO"
    },
    {
      "label": "Kostroma Oblast",
      "value": "KOS"
    },
    {
      "label": "Republic of Karelia",
      "value": "KR"
    },
    {
      "label": "Kursk Oblast",
      "value": "KRS"
    },
    {
      "label": "Krasnoyarsk Krai",
      "value": "KYA"
    },
    {
      "label": "Leningrad Oblast",
      "value": "LEN"
    },
    {
      "label": "Lipetsk Oblast",
      "value": "LIP"
    },
    {
      "label": "Magadan Oblast",
      "value": "MAG"
    },
    {
      "label": "Mari El Republic",
      "value": "ME"
    },
    {
      "label": "Republic of Mordovia",
      "value": "MO"
    },
    {
      "label": "Moscow Oblast",
      "value": "MOS"
    },
    {
      "label": "Moscow",
      "value": "MOW"
    },
    {
      "label": "Murmansk Oblast",
      "value": "MUR"
    },
    {
      "label": "Novgorod Oblast",
      "value": "NGR"
    },
    {
      "label": "Nizhny Novgorod Oblast",
      "value": "NIZ"
    },
    {
      "label": "Novosibirsk Oblast",
      "value": "NVS"
    },
    {
      "label": "Omsk Oblast",
      "value": "OMS"
    },
    {
      "label": "Orenburg Oblast",
      "value": "ORE"
    },
    {
      "label": "Oryol Oblast",
      "value": "ORL"
    },
    {
      "label": "Perm Krai",
      "value": "PER"
    },
    {
      "label": "Penza Oblast",
      "value": "PNZ"
    },
    {
      "label": "Primorsky Krai",
      "value": "PRI"
    },
    {
      "label": "Pskov Oblast",
      "value": "PSK"
    },
    {
      "label": "Rostov Oblast",
      "value": "ROS"
    },
    {
      "label": "Ryazan Oblast",
      "value": "RYA"
    },
    {
      "label": "Sakha Republic (Yakutia)",
      "value": "SA"
    },
    {
      "label": "Sakhalin Oblast",
      "value": "SAK"
    },
    {
      "label": "Samara Oblast",
      "value": "SAM"
    },
    {
      "label": "Saratov Oblast",
      "value": "SAR"
    },
    {
      "label": "Republic of North Ossetia–Alania",
      "value": "SE"
    },
    {
      "label": "Smolensk Oblast",
      "value": "SMO"
    },
    {
      "label": "Saint Petersburg",
      "value": "SPE"
    },
    {
      "label": "Stavropol Krai",
      "value": "STA"
    },
    {
      "label": "Sverdlovsk Oblast",
      "value": "SVE"
    },
    {
      "label": "Republic of Tatarstan",
      "value": "TA"
    },
    {
      "label": "Tambov Oblast",
      "value": "TAM"
    },
    {
      "label": "Tomsk Oblast",
      "value": "TOM"
    },
    {
      "label": "Tula Oblast",
      "value": "TUL"
    },
    {
      "label": "Tver Oblast",
      "value": "TVE"
    },
    {
      "label": "Tyva Republic",
      "value": "TY"
    },
    {
      "label": "Tyumen Oblast",
      "value": "TYU"
    },
    {
      "label": "Udmurtia",
      "value": "UD"
    },
    {
      "label": "Ulyanovsk Oblast",
      "value": "ULY"
    },
    {
      "label": "Volgograd Oblast",
      "value": "VGG"
    },
    {
      "label": "Vladimir Oblast",
      "value": "VLA"
    },
    {
      "label": "Vologda Oblast",
      "value": "VLG"
    },
    {
      "label": "Voronezh Oblast",
      "value": "VOR"
    },
    {
      "label": "Yamalo-Nenets Autonomous Okrug",
      "value": "YAN"
    },
    {
      "label": "Yaroslavl Oblast",
      "value": "YAR"
    },
    {
      "label": "Jewish Autonomous Oblast",
      "value": "YEV"
    },
    {
      "label": "Zabaykalsky Krai",
      "value": "ZAB"
    }
  ],
  "RW": [],
  "BL": [],
  "SH": [],
  "KN": [],
  "LC": [],
  "MF": [],
  "PM": [],
  "WS": [],
  "SM": [],
  "ST": [],
  "SA": [],
  "SN": [],
  "RS": [],
  "SC": [],
  "SL": [],
  "SG": [],
  "SX": [],
  "SK": [],
  "SI": [],
  "SB": [],
  "SO": [],
  "ZA": [
    {
      "label": "Eastern Cape",
      "value": "EC"
    },
    {
      "label": "Free State",
      "value": "FS"
    },
    {
      "label": "Gauteng",
      "value": "GP"
    },
    {
      "label": "Limpopo",
      "value": "LP"
    },
    {
      "label": "Mpumalanga",
      "value": "MP"
    },
    {
      "label": "Northern Cape",
      "value": "NC"
    },
    {
      "label": "KwaZulu-Natal",
      "value": "NL"
    },
    {
      "label": "North West",
      "value": "NW"
    },
    {
      "label": "Western Cape",
      "value": "WC"
    }
  ],
  "GS": [],
  "KR": [
    {
      "label": "Seoul",
      "value": "KR-11"
    },
    {
      "label": "Busan",
      "value": "KR-26"
    },
    {
      "label": "Daegu",
      "value": "KR-27"
    },
    {
      "label": "Incheon",
      "value": "KR-28"
    },
    {
      "label": "Gwangju",
      "value": "KR-29"
    },
    {
      "label": "Daejeon",
      "value": "KR-30"
    },
    {
      "label": "Ulsan",
      "value": "KR-31"
    },
    {
      "label": "Gyeonggi",
      "value": "KR-41"
    },
    {
      "label": "Gangwon",
      "value": "KR-42"
    },
    {
      "label": "Chungbuk",
      "value": "KR-43"
    },
    {
      "label": "Chungnam",
      "value": "KR-44"
    },
    {
      "label": "Jeonbuk",
      "value": "KR-45"
    },
    {
      "label": "Jeonnam",
      "value": "KR-46"
    },
    {
      "label": "Gyeongbuk",
      "value": "KR-47"
    },
    {
      "label": "Gyeongnam",
      "value": "KR-48"
    },
    {
      "label": "Jeju",
      "value": "KR-49"
    },
    {
      "label": "Sejong",
      "value": "KR-50"
    }
  ],
  "SS": [],
  "ES": [
    {
      "label": "Alicante",
      "value": "A"
    },
    {
      "label": "Albacete",
      "value": "AB"
    },
    {
      "label": "Almería",
      "value": "AL"
    },
    {
      "label": "Ávila",
      "value": "AV"
    },
    {
      "label": "Barcelona",
      "value": "B"
    },
    {
      "label": "Badajoz",
      "value": "BA"
    },
    {
      "label": "Vizcaya",
      "value": "BI"
    },
    {
      "label": "Burgos",
      "value": "BU"
    },
    {
      "label": "A Coruña",
      "value": "C"
    },
    {
      "label": "Cádiz",
      "value": "CA"
    },
    {
      "label": "Cáceres",
      "value": "CC"
    },
    {
      "label": "Ceuta",
      "value": "CE"
    },
    {
      "label": "Córdoba",
      "value": "CO"
    },
    {
      "label": "Ciudad Real",
      "value": "CR"
    },
    {
      "label": "Castellón",
      "value": "CS"
    },
    {
      "label": "Cuenca",
      "value": "CU"
    },
    {
      "label": "Las Palmas",
      "value": "GC"
    },
    {
      "label": "Girona",
      "value": "GI"
    },
    {
      "label": "Granada",
      "value": "GR"
    },
    {
      "label": "Guadalajara",
      "value": "GU"
    },
    {
      "label": "Huelva",
      "value": "H"
    },
    {
      "label": "Huesca",
      "value": "HU"
    },
    {
      "label": "Jaén",
      "value": "J"
    },
    {
      "label": "Lleida",
      "value": "L"
    },
    {
      "label": "León",
      "value": "LE"
    },
    {
      "label": "La Rioja",
      "value": "LO"
    },
    {
      "label": "Lugo",
      "value": "LU"
    },
    {
      "label": "Madrid",
      "value": "M"
    },
    {
      "label": "Málaga",
      "value": "MA"
    },
    {
      "label": "Melilla",
      "value": "ML"
    },
    {
      "label": "Murcia",
      "value": "MU"
    },
    {
      "label": "Navarra",
      "value": "NA"
    },
    {
      "label": "Asturias",
      "value": "O"
    },
    {
      "label": "Ourense",
      "value": "OR"
    },
    {
      "label": "Palencia",
      "value": "P"
    },
    {
      "label": "Balears",
      "value": "PM"
    },
    {
      "label": "Pontevedra",
      "value": "PO"
    },
    {
      "label": "Cantabria",
      "value": "S"
    },
    {
      "label": "Salamanca",
      "value": "SA"
    },
    {
      "label": "Sevilla",
      "value": "SE"
    },
    {
      "label": "Segovia",
      "value": "SG"
    },
    {
      "label": "Soria",
      "value": "SO"
    },
    {
      "label": "Guipúzcoa",
      "value": "SS"
    },
    {
      "label": "Tarragona",
      "value": "T"
    },
    {
      "label": "Teruel",
      "value": "TE"
    },
    {
      "label": "Santa Cruz de Tenerife",
      "value": "TF"
    },
    {
      "label": "Toledo",
      "value": "TO"
    },
    {
      "label": "Valencia",
      "value": "V"
    },
    {
      "label": "Valladolid",
      "value": "VA"
    },
    {
      "label": "Álava",
      "value": "VI"
    },
    {
      "label": "Zaragoza",
      "value": "Z"
    },
    {
      "label": "Zamora",
      "value": "ZA"
    }
  ],
  "LK": [],
  "VC": [],
  "SD": [],
  "SR": [],
  "SJ": [],
  "SE": [],
  "CH": [],
  "TW": [],
  "TJ": [],
  "TZ": [],
  "TH": [
    {
      "label": "Bangkok",
      "value": "TH-10"
    },
    {
      "label": "Samut Prakan",
      "value": "TH-11"
    },
    {
      "label": "Nonthaburi",
      "value": "TH-12"
    },
    {
      "label": "Pathum Thani",
      "value": "TH-13"
    },
    {
      "label": "Phra Nakhon Si Ayutthaya",
      "value": "TH-14"
    },
    {
      "label": "Ang Thong",
      "value": "TH-15"
    },
    {
      "label": "Lopburi",
      "value": "TH-16"
    },
    {
      "label": "Sing Buri",
      "value": "TH-17"
    },
    {
      "label": "Chai Nat",
      "value": "TH-18"
    },
    {
      "label": "Saraburi",
      "value": "TH-19"
    },
    {
      "label": "Chon Buri",
      "value": "TH-20"
    },
    {
      "label": "Rayong",
      "value": "TH-21"
    },
    {
      "label": "Chanthaburi",
      "value": "TH-22"
    },
    {
      "label": "Trat",
      "value": "TH-23"
    },
    {
      "label": "Chachoengsao",
      "value": "TH-24"
    },
    {
      "label": "Prachin Buri",
      "value": "TH-25"
    },
    {
      "label": "Nakhon Nayok",
      "value": "TH-26"
    },
    {
      "label": "Sa Kaeo",
      "value": "TH-27"
    },
    {
      "label": "Nakhon Ratchasima",
      "value": "TH-30"
    },
    {
      "label": "Buriram",
      "value": "TH-31"
    },
    {
      "label": "Surin",
      "value": "TH-32"
    },
    {
      "label": "Sisaket",
      "value": "TH-33"
    },
    {
      "label": "Ubon Ratchathani",
      "value": "TH-34"
    },
    {
      "label": "Yasothon",
      "value": "TH-35"
    },
    {
      "label": "Chaiyaphum",
      "value": "TH-36"
    },
    {
      "label": "Amnat Charoen",
      "value": "TH-37"
    },
    {
      "label": "Bueng Kan",
      "value": "TH-38"
    },
    {
      "label": "Nong Bua Lam Phu",
      "value": "TH-39"
    },
    {
      "label": "Khon Kaen",
      "value": "TH-40"
    },
    {
      "label": "Udon Thani",
      "value": "TH-41"
    },
    {
      "label": "Loei",
      "value": "TH-42"
    },
    {
      "label": "Nong Khai",
      "value": "TH-43"
    },
    {
      "label": "Maha Sarakham",
      "value": "TH-44"
    },
    {
      "label": "Roi Et",
      "value": "TH-45"
    },
    {
      "label": "Kalasin",
      "value": "TH-46"
    },
    {
      "label": "Sakon Nakhon",
      "value": "TH-47"
    },
    {
      "label": "Nakhon Phanom",
      "value": "TH-48"
    },
    {
      "label": "Mukdahan",
      "value": "TH-49"
    },
    {
      "label": "Chiang Mai",
      "value": "TH-50"
    },
    {
      "label": "Lamphun",
      "value": "TH-51"
    },
    {
      "label": "Lampang",
      "value": "TH-52"
    },
    {
      "label": "Uttaradit",
      "value": "TH-53"
    },
    {
      "label": "Phrae",
      "value": "TH-54"
    },
    {
      "label": "Nan",
      "value": "TH-55"
    },
    {
      "label": "Phayao",
      "value": "TH-56"
    },
    {
      "label": "Chiang Rai",
      "value": "TH-57"
    },
    {
      "label": "Mae Hong Son",
      "value": "TH-58"
    },
    {
      "label": "Nakhon Sawan",
      "value": "TH-60"
    },
    {
      "label": "Uthai Thani",
      "value": "TH-61"
    },
    {
      "label": "Kamphaeng Phet",
      "value": "TH-62"
    },
    {
      "label": "Tak",
      "value": "TH-63"
    },
    {
      "label": "Sukhothai",
      "value": "TH-64"
    },
    {
      "label": "Phitsanulok",
      "value": "TH-65"
    },
    {
      "label": "Phichit",
      "value": "TH-66"
    },
    {
      "label": "Phetchabun",
      "value": "TH-67"
    },
    {
      "label": "Ratchaburi",
      "value": "TH-70"
    },
    {
      "label": "Kanchanaburi",
      "value": "TH-71"
    },
    {
      "label": "Suphan Buri",
      "value": "TH-72"
    },
    {
      "label": "Nakhon Pathom",
      "value": "TH-73"
    },
    {
      "label": "Samut Sakhon",
      "value": "TH-74"
    },
    {
      "label": "Samut Songkhram",
      "value": "TH-75"
    },
    {
      "label": "Phetchaburi",
      "value": "TH-76"
    },
    {
      "label": "Prachuap Khiri Khan",
      "value": "TH-77"
    },
    {
      "label": "Nakhon Si Thammarat",
      "value": "TH-80"
    },
    {
      "label": "Krabi",
      "value": "TH-81"
    },
    {
      "label": "Phangnga",
      "value": "TH-82"
    },
    {
      "label": "Phuket",
      "value": "TH-83"
    },
    {
      "label": "Surat Thani",
      "value": "TH-84"
    },
    {
      "label": "Ranong",
      "value": "TH-85"
    },
    {
      "label": "Chumphon",
      "value": "TH-86"
    },
    {
      "label": "Songkhla",
      "value": "TH-90"
    },
    {
      "label": "Satun",
      "value": "TH-91"
    },
    {
      "label": "Trang",
      "value": "TH-92"
    },
    {
      "label": "Phatthalung",
      "value": "TH-93"
    },
    {
      "label": "Pattani",
      "value": "TH-94"
    },
    {
      "label": "Yala",
      "value": "TH-95"
    },
    {
      "label": "Narathiwat",
      "value": "TH-96"
    },
    {
      "label": "Pattaya",
      "value": "TH-S"
    }
  ],
  "TL": [],
  "TG": [],
  "TK": [],
  "TO": [],
  "TT": [],
  "TN": [],
  "TR": [],
  "TM": [],
  "TC": [],
  "TV": [],
  "UG": [],
  "UA": [],
  "AE": [
    {
      "label": "Ajman",
      "value": "AJ"
    },
    {
      "label": "Abu Dhabi",
      "value": "AZ"
    },
    {
      "label": "Dubai",
      "value": "DU"
    },
    {
      "label": "Fujairah",
      "value": "FU"
    },
    {
      "label": "Ras al-Khaimah",
      "value": "RK"
    },
    {
      "label": "Sharjah",
      "value": "SH"
    },
    {
      "label": "Umm al-Quwain",
      "value": "UQ"
    }
  ],
  "GB": [
    {
      "label": "British Forces",
      "value": "BFP"
    },
    {
      "label": "England",
      "value": "ENG"
    },
    {
      "label": "Northern Ireland",
      "value": "NIR"
    },
    {
      "label": "Scotland",
      "value": "SCT"
    },
    {
      "label": "Wales",
      "value": "WLS"
    }
  ],
  "US": [
    {
      "label": "Armed Forces Americas",
      "value": "AA"
    },
    {
      "label": "Armed Forces Europe",
      "value": "AE"
    },
    {
      "label": "Alaska",
      "value": "AK"
    },
    {
      "label": "Alabama",
      "value": "AL"
    },
    {
      "label": "Armed Forces Pacific",
      "value": "AP"
    },
    {
      "label": "Arkansas",
      "value": "AR"
    },
    {
      "label": "American Samoa",
      "value": "AS"
    },
    {
      "label": "Arizona",
      "value": "AZ"
    },
    {
      "label": "California",
      "value": "CA"
    },
    {
      "label": "Colorado",
      "value": "CO"
    },
    {
      "label": "Connecticut",
      "value": "CT"
    },
    {
      "label": "District of Columbia",
      "value": "DC"
    },
    {
      "label": "Delaware",
      "value": "DE"
    },
    {
      "label": "Florida",
      "value": "FL"
    },
    {
      "label": "Federated States of Micronesia",
      "value": "FM"
    },
    {
      "label": "Georgia",
      "value": "GA"
    },
    {
      "label": "Guam",
      "value": "GU"
    },
    {
      "label": "Hawaii",
      "value": "HI"
    },
    {
      "label": "Iowa",
      "value": "IA"
    },
    {
      "label": "Idaho",
      "value": "ID"
    },
    {
      "label": "Illinois",
      "value": "IL"
    },
    {
      "label": "Indiana",
      "value": "IN"
    },
    {
      "label": "Kansas",
      "value": "KS"
    },
    {
      "label": "Kentucky",
      "value": "KY"
    },
    {
      "label": "Louisiana",
      "value": "LA"
    },
    {
      "label": "Massachusetts",
      "value": "MA"
    },
    {
      "label": "Maryland",
      "value": "MD"
    },
    {
      "label": "Maine",
      "value": "ME"
    },
    {
      "label": "Marshall Islands",
      "value": "MH"
    },
    {
      "label": "Michigan",
      "value": "MI"
    },
    {
      "label": "Minnesota",
      "value": "MN"
    },
    {
      "label": "Missouri",
      "value": "MO"
    },
    {
      "label": "Northern Mariana Islands",
      "value": "MP"
    },
    {
      "label": "Mississippi",
      "value": "MS"
    },
    {
      "label": "Montana",
      "value": "MT"
    },
    {
      "label": "North Carolina",
      "value": "NC"
    },
    {
      "label": "North Dakota",
      "value": "ND"
    },
    {
      "label": "Nebraska",
      "value": "NE"
    },
    {
      "label": "New Hampshire",
      "value": "NH"
    },
    {
      "label": "New Jersey",
      "value": "NJ"
    },
    {
      "label": "New Mexico",
      "value": "NM"
    },
    {
      "label": "Nevada",
      "value": "NV"
    },
    {
      "label": "New York",
      "value": "NY"
    },
    {
      "label": "Ohio",
      "value": "OH"
    },
    {
      "label": "Oklahoma",
      "value": "OK"
    },
    {
      "label": "Oregon",
      "value": "OR"
    },
    {
      "label": "Pennsylvania",
      "value": "PA"
    },
    {
      "label": "Puerto Rico",
      "value": "PR"
    },
    {
      "label": "Palau",
      "value": "PW"
    },
    {
      "label": "Rhode Island",
      "value": "RI"
    },
    {
      "label": "South Carolina",
      "value": "SC"
    },
    {
      "label": "South Dakota",
      "value": "SD"
    },
    {
      "label": "Tennessee",
      "value": "TN"
    },
    {
      "label": "Texas",
      "value": "TX"
    },
    {
      "label": "Utah",
      "value": "UT"
    },
    {
      "label": "Virginia",
      "value": "VA"
    },
    {
      "label": "Virgin Islands",
      "value": "VI"
    },
    {
      "label": "Vermont",
      "value": "VT"
    },
    {
      "label": "Washington",
      "value": "WA"
    },
    {
      "label": "Wisconsin",
      "value": "WI"
    },
    {
      "label": "West Virginia",
      "value": "WV"
    },
    {
      "label": "Wyoming",
      "value": "WY"
    }
  ],
  "UM": [],
  "UY": [
    {
      "label": "Artigas",
      "value": "UY-AR"
    },
    {
      "label": "Canelones",
      "value": "UY-CA"
    },
    {
      "label": "Cerro Largo",
      "value": "UY-CL"
    },
    {
      "label": "Colonia",
      "value": "UY-CO"
    },
    {
      "label": "Durazno",
      "value": "UY-DU"
    },
    {
      "label": "Florida",
      "value": "UY-FD"
    },
    {
      "label": "Flores",
      "value": "UY-FS"
    },
    {
      "label": "Lavalleja",
      "value": "UY-LA"
    },
    {
      "label": "Maldonado",
      "value": "UY-MA"
    },
    {
      "label": "Montevideo",
      "value": "UY-MO"
    },
    {
      "label": "Paysandú",
      "value": "UY-PA"
    },
    {
      "label": "Río Negro",
      "value": "UY-RN"
    },
    {
      "label": "Rocha",
      "value": "UY-RO"
    },
    {
      "label": "Rivera",
      "value": "UY-RV"
    },
    {
      "label": "Salto",
      "value": "UY-SA"
    },
    {
      "label": "San José",
      "value": "UY-SJ"
    },
    {
      "label": "Soriano",
      "value": "UY-SO"
    },
    {
      "label": "Tacuarembó",
      "value": "UY-TA"
    },
    {
      "label": "Treinta y Tres",
      "value": "UY-TT"
    }
  ],
  "UZ": [],
  "VU": [],
  "VE": [
    {
      "label": "Distrito Capital",
      "value": "VE-A"
    },
    {
      "label": "Anzoátegui",
      "value": "VE-B"
    },
    {
      "label": "Apure",
      "value": "VE-C"
    },
    {
      "label": "Aragua",
      "value": "VE-D"
    },
    {
      "label": "Barinas",
      "value": "VE-E"
    },
    {
      "label": "Bolívar",
      "value": "VE-F"
    },
    {
      "label": "Carabobo",
      "value": "VE-G"
    },
    {
      "label": "Cojedes",
      "value": "VE-H"
    },
    {
      "label": "Falcón",
      "value": "VE-I"
    },
    {
      "label": "Guárico",
      "value": "VE-J"
    },
    {
      "label": "Lara",
      "value": "VE-K"
    },
    {
      "label": "Mérida",
      "value": "VE-L"
    },
    {
      "label": "Miranda",
      "value": "VE-M"
    },
    {
      "label": "Monagas",
      "value": "VE-N"
    },
    {
      "label": "Nueva Esparta",
      "value": "VE-O"
    },
    {
      "label": "Portuguesa",
      "value": "VE-P"
    },
    {
      "label": "Sucre",
      "value": "VE-R"
    },
    {
      "label": "Táchira",
      "value": "VE-S"
    },
    {
      "label": "Trujillo",
      "value": "VE-T"
    },
    {
      "label": "Yaracuy",
      "value": "VE-U"
    },
    {
      "label": "Zulia",
      "value": "VE-V"
    },
    {
      "label": "Dependencias Federales",
      "value": "VE-W"
    },
    {
      "label": "La Guaira",
      "value": "VE-X"
    },
    {
      "label": "Delta Amacuro",
      "value": "VE-Y"
    },
    {
      "label": "Amazonas",
      "value": "VE-Z"
    }
  ],
  "VN": [],
  "VG": [],
  "WF": [],
  "EH": [],
  "YE": [],
  "ZM": [],
  "ZW": [],
  "AC": [],
  "TA": []
}

export const PROVINCE_DICT = {
  AF: {},
  AX: {},
  AL: {},
  DZ: {},
  AD: {},
  AO: {},
  AI: {},
  AG: {},
  AR: {
    C: "Ciudad Autónoma de Buenos Aires",
    B: "Buenos Aires",
    K: "Catamarca",
    H: "Chaco",
    U: "Chubut",
    X: "Córdoba",
    W: "Corrientes",
    E: "Entre Ríos",
    P: "Formosa",
    Y: "Jujuy",
    L: "La Pampa",
    F: "La Rioja",
    M: "Mendoza",
    N: "Misiones",
    Q: "Neuquén",
    R: "Río Negro",
    A: "Salta",
    J: "San Juan",
    D: "San Luis",
    Z: "Santa Cruz",
    S: "Santa Fe",
    G: "Santiago Del Estero",
    V: "Tierra Del Fuego",
    T: "Tucumán",
  },
  AM: {},
  AW: {},
  AC: {},
  AU: {
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "South Australia",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Western Australia",
  },
  AT: {},
  AZ: {},
  BS: {},
  BH: {},
  BD: {},
  BB: {},
  BY: {},
  BE: {},
  BZ: {},
  BJ: {},
  BM: {},
  BT: {},
  BO: {},
  BA: {},
  BW: {},
  BV: {},
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    ES: "Espírito Santo",
    DF: "Distrito Federal",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RJ: "Rio de Janeiro",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  IO: {},
  BN: {},
  BG: {},
  BF: {},
  BI: {},
  KH: {},
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon",
  },
  CV: {},
  BQ: {},
  KY: {},
  CF: {},
  TD: {},
  CL: {
    AP: "Arica and Parinacota",
    TA: "Tarapacá",
    AN: "Antofagasta",
    AT: "Atacama",
    CO: "Coquimbo",
    VS: "Valparaíso",
    RM: "Santiago",
    LI: "O'Higgins",
    ML: "Maule",
    NB: "Ñuble",
    BI: "Biobío",
    AR: "Araucanía",
    LR: "Los Ríos",
    LL: "Los Lagos",
    AI: "Aysén",
    MA: "Magallanes",
  },
  CN: {
    AH: "Anhui",
    BJ: "Beijing",
    CQ: "Chongqing",
    FJ: "Fujian",
    GS: "Gansu",
    GD: "Guangdong",
    GX: "Guangxi",
    GZ: "Guizhou",
    HI: "Hainan",
    HE: "Hebei",
    HL: "Heilongjiang",
    HA: "Henan",
    HB: "Hubei",
    HN: "Hunan",
    NM: "Inner Mongolia",
    JS: "Jiangsu",
    JX: "Jiangxi",
    JL: "Jilin",
    LN: "Liaoning",
    NX: "Ningxia",
    QH: "Qinghai",
    SN: "Shaanxi",
    SD: "Shandong",
    SH: "Shanghai",
    SX: "Shanxi",
    SC: "Sichuan",
    TJ: "Tianjin",
    YZ: "Xizang",
    XJ: "Xinjiang",
    YN: "Yunnan",
    ZJ: "Zhejiang",
  },
  CX: {},
  CC: {},
  CO: {
    DC: "Bogotá, D.C.",
    AMA: "Amazonas",
    ANT: "Antioquia",
    ARA: "Arauca",
    ATL: "Atlántico",
    BOL: "Bolívar",
    BOY: "Boyacá",
    CAL: "Caldas",
    CAQ: "Caquetá",
    CAS: "Casanare",
    CAU: "Cauca",
    CES: "Cesar",
    CHO: "Chocó",
    COR: "Córdoba",
    CUN: "Cundinamarca",
    GUA: "Guainía",
    GUV: "Guaviare",
    HUI: "Huila",
    LAG: "La Guajira",
    MAG: "Magdalena",
    MET: "Meta",
    NAR: "Nariño",
    NSA: "Norte de Santander",
    PUT: "Putumayo",
    QUI: "Quindío",
    RIS: "Risaralda",
    SAP: "San Andrés, Providencia y Santa Catalina",
    SAN: "Santander",
    SUC: "Sucre",
    TOL: "Tolima",
    VAC: "Valle del Cauca",
    VAU: "Vaupés",
    VID: "Vichada",
  },
  KM: {},
  CG: {},
  CD: {},
  CK: {},
  CR: {},
  HR: {},
  CU: {},
  CW: {},
  CY: {},
  CZ: {},
  CI: {},
  DK: {},
  DJ: {},
  DM: {},
  DO: {},
  EC: {},
  EG: {
    SU: "6th of October",
    SHR: "Al Sharqia",
    ALX: "Alexandria",
    ASN: "Aswan",
    AST: "Asyut",
    BH: "Beheira",
    BNS: "Beni Suef",
    C: "Cairo",
    DK: "Dakahlia",
    DT: "Damietta",
    FYM: "Faiyum",
    GH: "Gharbia",
    GZ: "Giza",
    HU: "Helwan",
    IS: "Ismailia",
    KFS: "Kafr el-Sheikh",
    LX: "Luxor",
    MT: "Matrouh",
    MN: "Minya",
    MNF: "Monufia",
    WAD: "New Valley",
    SIN: "North Sinai",
    PTS: "Port Said",
    KB: "Qalyubia",
    KN: "Qena",
    BA: "Red Sea",
    SHG: "Sohag",
    JS: "South Sinai",
    SUZ: "Suez",
  },
  SV: {},
  GQ: {},
  ER: {},
  EE: {},
  SZ: {},
  ET: {},
  FK: {},
  FO: {},
  FJ: {},
  FI: {},
  FR: {
    "84": "Auvergne-Rhône-Alpes\n",
    "27\t": "Bourgogne-Franche-Comté",
    "53": "Brittany (Bretagne)",
    "24": "Centre-Val de Loire",
    "94": "Corsica (Corse)",
    "44": "Grand Est",
    "32": "Hauts-de-France",
    "11": "Île-de-France",
    "28": "Normandy (Normandie)",
    "75": "Nouvelle-Aquitaine",
    "76": "Occitanie",
    "52": "Pays de la Loire",
    "93": "Provence-Alpes-Côte d'Azur",
    "01": "Guadeloupe",
    "02": "Martinique",
    "03": "Guyane (French Guiana)",
    "04": "La Réunion",
    "06": "Mayotte",
  },
  GF: {},
  PF: {},
  TF: {},
  GA: {},
  GM: {},
  GE: {},
  DE: {},
  GH: {},
  GI: {},
  GR: {},
  GL: {},
  GD: {},
  GP: {},
  GT: {
    AVE: "Alta Verapaz",
    BVE: "Baja Verapaz",
    CMT: "Chimaltenango",
    CQM: "Chiquimula",
    EPR: "El Progreso",
    ESC: "Escuintla",
    GUA: "Guatemala",
    HUE: "Huehuetenango",
    IZA: "Izabal",
    JAL: "Jalapa",
    JUT: "Jutiapa",
    PET: "Petén",
    QUE: "Quetzaltenango",
    QUI: "Quiché",
    RET: "Retalhuleu",
    SAC: "Sacatepéquez",
    SMA: "San Marcos",
    SRO: "Santa Rosa",
    SOL: "Sololá",
    SUC: "Suchitepéquez",
    TOT: "Totonicapán",
    ZAC: "Zacapa",
  },
  GG: {},
  GN: {},
  GW: {},
  GY: {},
  HT: {},
  HM: {},
  VA: {},
  HN: {},
  HK: {
    HK: "Hong Kong Island",
    KL: "Kowloon",
    NT: "New Territories",
  },
  HU: {},
  IS: {},
  IN: {
    AN: "Andaman and Nicobar Islands",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CG: "Chhattisgarh",
    DN: "Dadra and Nagar Haveli",
    DD: "Daman and Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu and Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LA: "Ladakh",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TS: "Telangana",
    TR: "Tripura",
    UP: "Uttar Pradesh",
    UK: "Uttarakhand",
    WB: "West Bengal",
  },
  ID: {
    AC: "Aceh",
    BA: "Bali",
    BB: "Bangka Belitung",
    BT: "Banten",
    BE: "Bengkulu",
    JT: "Jawa Tengah",
    KT: "Kalimantan Tengah",
    ST: "Sulawesi Tengah",
    JI: "Jawa Timur",
    KI: "Kalimantan Timur",
    NT: "Nusa Tenggara Timur",
    GO: "Gorontalo",
    JK: "Jakarta",
    JA: "Jambi",
    LA: "Lampung",
    MA: "Maluku",
    KU: "Kalimantan Utara",
    MU: "Maluku Utara",
    SA: "Sulawesi Utara",
    SU: "North Sumatra",
    PA: "Papua",
    RI: "Riau",
    KR: "Kepulauan Riau",
    KS: "Kalimantan Selatan",
    SN: "Sulawesi Selatan",
    SS: "South Sumatra",
    SG: "Sulawesi Tenggara",
    JB: "Jawa Barat",
    KB: "Kalimantan Barat",
    NB: "Nusa Tenggara Barat",
    PB: "Papua Barat",
    SR: "Sulawesi Barat",
    SB: "West Sumatra",
    YO: "Yogyakarta",
  },
  IR: {},
  IQ: {},
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IM: {},
  IL: {},
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Firenze",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genova",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    AQ: "L'Aquila",
    MC: "Macerata",
    MN: "Mantova",
    MS: "Massa-Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milano",
    MO: "Modena",
    MB: "Monza e Brianza",
    NA: "Napoli",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padova",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro e Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Roma",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    BZ: "Bolzano",
    SR: "Siracusa",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Torino",
    UD: "Udine",
    VA: "Varese",
    VE: "Venezia",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  JM: {},
  JP: {
    "JP-01": "Hokkaidō",
    "JP-02": "Aomori",
    "JP-03": "Iwate",
    "JP-04": "Miyagi",
    "JP-05": "Akita",
    "JP-06": "Yamagata",
    "JP-07": "Fukushima",
    "JP-08": "Ibaraki",
    "JP-09": "Tochigi",
    "JP-10": "Gunma",
    "JP-11": "Saitama",
    "JP-12": "Chiba",
    "JP-13": "Tōkyō",
    "JP-14": "Kanagawa",
    "JP-15": "Niigata",
    "JP-16": "Toyama",
    "JP-17": "Ishikawa",
    "JP-18": "Fukui",
    "JP-19": "Yamanashi",
    "JP-20": "Nagano",
    "JP-21": "Gifu",
    "JP-22": "Shizuoka",
    "JP-23": "Aichi",
    "JP-24": "Mie",
    "JP-25": "Shiga",
    "JP-26": "Kyōto",
    "JP-27": "Ōsaka",
    "JP-28": "Hyōgo",
    "JP-29": "Nara",
    "JP-30": "Wakayama",
    "JP-31": "Tottori",
    "JP-32": "Shimane",
    "JP-33": "Okayama",
    "JP-34": "Hiroshima",
    "JP-35": "Yamaguchi",
    "JP-36": "Tokushima",
    "JP-37": "Kagawa",
    "JP-38": "Ehime",
    "JP-39": "Kōchi",
    "JP-40": "Fukuoka",
    "JP-41": "Saga",
    "JP-42": "Nagasaki",
    "JP-43": "Kumamoto",
    "JP-44": "Ōita",
    "JP-45": "Miyazaki",
    "JP-46": "Kagoshima",
    "JP-47": "Okinawa",
  },
  JE: {},
  JO: {},
  KZ: {},
  KE: {},
  KI: {},
  KP: {},
  XK: {},
  KW: {},
  KG: {},
  LA: {},
  LV: {},
  LB: {},
  LS: {},
  LR: {},
  LY: {},
  LI: {},
  LT: {},
  LU: {},
  MO: {},
  MG: {},
  MW: {},
  MY: {
    JHR: "Johor",
    KDH: "Kedah",
    KTN: "Kelantan",
    KUL: "Kuala Lumpur",
    LBN: "Labuan",
    MLK: "Melaka",
    NSN: "Negeri Sembilan",
    PHG: "Pahang",
    PNG: "Penang",
    PRK: "Perak",
    PLS: "Perlis",
    PJY: "Putrajaya",
    SBH: "Sabah",
    SWK: "Sarawak",
    SGR: "Selangor",
    TRG: "Terengganu",
  },
  MV: {},
  ML: {},
  MT: {},
  MQ: {},
  MR: {},
  MU: {},
  YT: {},
  MX: {
    AGS: "Aguascalientes",
    BC: "Baja California",
    BCS: "Baja California Sur",
    CAMP: "Campeche",
    CHIS: "Chiapas",
    CHIH: "Chihuahua",
    DF: "Ciudad de México",
    COAH: "Coahuila",
    COL: "Colima",
    DGO: "Durango",
    GTO: "Guanajuato",
    GRO: "Guerrero",
    HGO: "Hidalgo",
    JAL: "Jalisco",
    MEX: "México",
    MICH: "Michoacán",
    MOR: "Morelos",
    NAY: "Nayarit",
    NL: "Nuevo León",
    OAX: "Oaxaca",
    PUE: "Puebla",
    QRO: "Querétaro",
    "Q ROO": "Quintana Roo",
    SLP: "San Luis Potosí",
    SIN: "Sinaloa",
    SON: "Sonora",
    TAB: "Tabasco",
    TAMPS: "Tamaulipas",
    TLAX: "Tlaxcala",
    VER: "Veracruz",
    YUC: "Yucatán",
    ZAC: "Zacatecas",
  },
  MD: {},
  MC: {},
  MN: {},
  ME: {},
  MS: {},
  MA: {},
  MZ: {},
  MM: {},
  NA: {},
  NR: {},
  NP: {},
  NL: {},
  AN: {},
  NC: {},
  NZ: {
    AUK: "Auckland",
    BOP: "Bay of Plenty",
    CAN: "Canterbury",
    CIT: "Chatham Islands",
    GIS: "Gisborne",
    HKB: "Hawke's Bay",
    MWT: "Manawatu-Wanganui",
    MBH: "Marlborough",
    NSN: "Nelson",
    NTL: "Northland",
    OTA: "Otago",
    STL: "Southland",
    TKI: "Taranaki",
    TAS: "Tasman",
    WKO: "Waikato",
    WGN: "Wellington",
    WTC: "West Coast",
  },
  NI: {},
  NE: {},
  NG: {
    AB: "Abia",
    AD: "Adamawa",
    AK: "Akwa Ibom",
    AN: "Anambra",
    BA: "Bauchi",
    BY: "Bayelsa",
    BE: "Benue",
    BO: "Borno",
    CR: "Cross River",
    DE: "Delta",
    EB: "Ebonyi",
    ED: "Edo",
    EK: "Ekiti",
    EN: "Enugu",
    FC: "Abuja Federal Capital Territory",
    GO: "Gombe",
    IM: "Imo",
    JI: "Jigawa",
    KD: "Kaduna",
    KN: "Kano",
    KT: "Katsina",
    KE: "Kebbi",
    KO: "Kogi",
    KW: "Kwara",
    LA: "Lagos",
    NA: "Nasarawa",
    NI: "Niger",
    OG: "Ogun",
    ON: "Ondo",
    OS: "Osun",
    OY: "Oyo",
    PL: "Plateau",
    RI: "Rivers",
    SO: "Sokoto",
    TA: "Taraba",
    YO: "Yobe",
    ZA: "Zamfara",
  },
  NU: {},
  NF: {},
  MK: {},
  NO: {},
  OM: {},
  PK: {},
  PS: {},
  PA: {
    "PA-1": "Bocas del Toro",
    "PA-4": "Chiriquí",
    "PA-2": "Coclé",
    "PA-3": "Colón",
    "PA-5": "Darién",
    "PA-EM": "Emberá",
    "PA-KY": "Kuna Yala",
    "PA-6": "Herrera",
    "PA-7": "Los Santos",
    "PA-NB": "Ngöbe-Buglé",
    "PA-8": "Panamá",
    "PA-9": "Veraguas",
    "PA-10": "Panamá Oeste",
  },
  PG: {},
  PY: {},
  PE: {
    "PE-AMA": "Amazonas",
    "PE-ANC": "Áncash",
    "PE-APU": "Apurímac",
    "PE-ARE": "Arequipa",
    "PE-AYA": "Ayacucho",
    "PE-CAJ": "Cajamarca",
    "PE-CUS": "Cuzco",
    "PE-CAL": "Callao",
    "PE-HUV": "Huancavelica",
    "PE-HUC": "Huánuco",
    "PE-ICA": "Ica",
    "PE-JUN": "Junín",
    "PE-LAL": "La Libertad",
    "PE-LAM": "Lambayeque",
    "PE-LIM": "Lima (departamento)",
    "PE-LMA": "Lima (provincia)",
    "PE-LOR": "Loreto",
    "PE-MDD": "Madre de Dios",
    "PE-MOQ": "Moquegua",
    "PE-PAS": "Pasco",
    "PE-PIU": "Piura",
    "PE-PUN": "Puno",
    "PE-SAM": "San Martín",
    "PE-TAC": "Tacna",
    "PE-TUM": "Tumbes",
    "PE-UCA": "Ucayali",
  },
  PH: {
    "PH-ABR": "Abra",
    "PH-AGN": "Agusan del Norte",
    "PH-AGS": "Agusan del Sur",
    "PH-AKL": "Aklan",
    "PH-ALB": "Albay",
    "PH-ANT": "Antique",
    "PH-APA": "Apayao",
    "PH-AUR": "Aurora",
    "PH-BAS": "Basilan",
    "PH-BAN": "Bataan",
    "PH-BTN": "Batanes",
    "PH-BTG": "Batangas",
    "PH-BEN": "Benguet",
    "PH-BIL": "Biliran",
    "PH-BOH": "Bohol",
    "PH-BUK": "Bukidnon",
    "PH-BUL": "Bulacan",
    "PH-CAG": "Cagayan",
    "PH-CAN": "Camarines Norte",
    "PH-CAS": "Camarines Sur",
    "PH-CAM": "Camiguin",
    "PH-CAP": "Capiz",
    "PH-CAT": "Catanduanes",
    "PH-CAV": "Cavite",
    "PH-CEB": "Cebu",
    "PH-COM": "Davao de Oro",
    "PH-NCO": "Cotabato",
    "PH-DVO": "Davao Occidental",
    "PH-DAO": "Davao Oriental",
    "PH-DAV": "Davao del Norte",
    "PH-DAS": "Davao del Sur",
    "PH-DIN": "Dinagat Islands",
    "PH-EAS": "Eastern Samar",
    "PH-GUI": "Guimaras",
    "PH-IFU": "Ifugao",
    "PH-ILN": "Ilocos Norte",
    "PH-ILS": "Ilocos Sur",
    "PH-ILI": "Iloilo",
    "PH-ISA": "Isabela",
    "PH-KAL": "Kalinga",
    "PH-LUN": "La Union",
    "PH-LAG": "Laguna",
    "PH-LAN": "Lanao del Norte",
    "PH-LAS": "Lanao del Sur",
    "PH-LEY": "Leyte",
    "PH-MAG": "Maguindanao",
    "PH-MAD": "Marinduque",
    "PH-MAS": "Masbate",
    "PH-00": "Metro Manila",
    "PH-MSC": "Misamis Occidental",
    "PH-MSR": "Misamis Oriental",
    "PH-MOU": "Mountain Province",
    "PH-NEC": "Negros Occidental",
    "PH-NER": "Negros Oriental",
    "PH-NSA": "Northern Samar",
    "PH-NUE": "Nueva Ecija",
    "PH-NUV": "Nueva Vizcaya",
    "PH-MDC": "Occidental Mindoro",
    "PH-MDR": "Oriental Mindoro",
    "PH-PLW": "Palawan",
    "PH-PAM": "Pampanga",
    "PH-PAN": "Pangasinan",
    "PH-QUE": "Quezon",
    "PH-QUI": "Quirino",
    "PH-RIZ": "Rizal",
    "PH-ROM": "Romblon",
    "PH-WSA": "Samar",
    "PH-SAR": "Sarangani",
    "PH-SIG": "Siquijor",
    "PH-SOR": "Sorsogon",
    "PH-SCO": "South Cotabato",
    "PH-SLE": "Southern Leyte",
    "PH-SUK": "Sultan Kudarat",
    "PH-SLU": "Sulu",
    "PH-SUN": "Surigao del Norte",
    "PH-SUR": "Surigao del Sur",
    "PH-TAR": "Tarlac",
    "PH-TAW": "Tawi-Tawi",
    "PH-ZMB": "Zambales",
    "PH-ZSI": "Zamboanga Sibugay",
    "PH-ZAN": "Zamboanga del Norte",
    "PH-ZAS": "Zamboanga del Sur",
  },
  PN: {},
  PL: {},
  PT: {
    "PT-01": "Aveiro",
    "PT-20": "Açores",
    "PT-02": "Beja",
    "PT-03": "Braga",
    "PT-04": "Bragança",
    "PT-05": "Castelo Branco",
    "PT-06": "Coimbra",
    "PT-07": "Évora",
    "PT-08": "Faro",
    "PT-09": "Guarda",
    "PT-10": "Leiria",
    "PT-11": "Lisboa",
    "PT-30": "Madeira",
    "PT-12": "Portalegre",
    "PT-13": "Porto",
    "PT-14": "Santarém",
    "PT-15": "Setúbal",
    "PT-16": "Viana do Castelo",
    "PT-17": "Vila Real",
    "PT-18": "Viseu",
  },
  QA: {},
  CM: {},
  RE: {},
  RO: {
    AB: "Alba",
    AR: "Arad",
    AG: "Argeș",
    BC: "Bacău",
    BH: "Bihor",
    BN: "Bistrița-Năsăud",
    BT: "Botoșani",
    BR: "Brăila",
    BV: "Brașov",
    B: "București",
    BZ: "Buzău",
    CS: "Caraș-Severin",
    CJ: "Cluj",
    CT: "Constanța",
    CV: "Covasna",
    CL: "Călărași",
    DJ: "Dolj",
    DB: "Dâmbovița",
    GL: "Galați",
    GR: "Giurgiu",
    GJ: "Gorj",
    HR: "Harghita",
    HD: "Hunedoara",
    IL: "Ialomița",
    IS: "Iași",
    IF: "Ilfov",
    MM: "Maramureș",
    MH: "Mehedinți",
    MS: "Mureș",
    NT: "Neamț",
    OT: "Olt",
    PH: "Prahova",
    SJ: "Sălaj",
    SM: "Satu Mare",
    SB: "Sibiu",
    SV: "Suceava",
    TR: "Teleorman",
    TM: "Timiș",
    TL: "Tulcea",
    VL: "Vâlcea",
    VS: "Vaslui",
    VN: "Vrancea",
  },
  RU: {
    AD: "Republic of Adygeya",
    AL: "Altai Republic",
    ALT: "Altai Krai",
    AMU: "Amur Oblast",
    ARK: "Arkhangelsk Oblast",
    AST: "Astrakhan Oblast",
    BA: "Republic of Bashkortostan",
    BEL: "Belgorod Oblast",
    BRY: "Bryansk Oblast",
    BU: "Republic of Buryatia",
    CE: "Chechen Republic",
    CHE: "Chelyabinsk Oblast",
    CHU: "Chukotka Autonomous Okrug",
    CU: "Chuvash Republic",
    DA: "Republic of Dagestan",
    IN: "Republic of Ingushetia",
    IRK: "Irkutsk Oblast",
    IVA: "Ivanovo Oblast",
    YEV: "Jewish Autonomous Oblast",
    KB: "Kabardino-Balkarian Republic",
    KGD: "Kaliningrad Oblast",
    KL: "Republic of Kalmykia",
    KLU: "Kaluga Oblast",
    KAM: "Kamchatka Krai",
    KC: "Karachay–Cherkess Republic",
    KR: "Republic of Karelia",
    KEM: "Kemerovo Oblast",
    KHA: "Khabarovsk Krai",
    KK: "Republic of Khakassia",
    KHM: "Khanty-Mansi Autonomous Okrug",
    KIR: "Kirov Oblast",
    KO: "Komi Republic",
    KOS: "Kostroma Oblast",
    KDA: "Krasnodar Krai",
    KYA: "Krasnoyarsk Krai",
    KGN: "Kurgan Oblast",
    KRS: "Kursk Oblast",
    LEN: "Leningrad Oblast",
    LIP: "Lipetsk Oblast",
    MAG: "Magadan Oblast",
    ME: "Mari El Republic",
    MO: "Republic of Mordovia",
    MOW: "Moscow",
    MOS: "Moscow Oblast",
    MUR: "Murmansk Oblast",
    NIZ: "Nizhny Novgorod Oblast",
    SE: "Republic of North Ossetia–Alania",
    NGR: "Novgorod Oblast",
    NVS: "Novosibirsk Oblast",
    OMS: "Omsk Oblast",
    ORE: "Orenburg Oblast",
    ORL: "Oryol Oblast",
    PNZ: "Penza Oblast",
    PER: "Perm Krai",
    PRI: "Primorsky Krai",
    PSK: "Pskov Oblast",
    ROS: "Rostov Oblast",
    RYA: "Ryazan Oblast",
    SPE: "Saint Petersburg",
    SA: "Sakha Republic (Yakutia)",
    SAK: "Sakhalin Oblast",
    SAM: "Samara Oblast",
    SAR: "Saratov Oblast",
    SMO: "Smolensk Oblast",
    STA: "Stavropol Krai",
    SVE: "Sverdlovsk Oblast",
    TAM: "Tambov Oblast",
    TA: "Republic of Tatarstan",
    TOM: "Tomsk Oblast",
    TUL: "Tula Oblast",
    TY: "Tyva Republic",
    TVE: "Tver Oblast",
    TYU: "Tyumen Oblast",
    UD: "Udmurtia",
    ULY: "Ulyanovsk Oblast",
    VLA: "Vladimir Oblast",
    VGG: "Volgograd Oblast",
    VLG: "Vologda Oblast",
    VOR: "Voronezh Oblast",
    YAN: "Yamalo-Nenets Autonomous Okrug",
    YAR: "Yaroslavl Oblast",
    ZAB: "Zabaykalsky Krai",
  },
  RW: {},
  BL: {},
  SH: {},
  KN: {},
  LC: {},
  MF: {},
  PM: {},
  WS: {},
  SM: {},
  ST: {},
  SA: {},
  SN: {},
  RS: {},
  SC: {},
  SL: {},
  SG: {},
  SX: {},
  SK: {},
  SI: {},
  SB: {},
  SO: {},
  ZA: {
    EC: "Eastern Cape",
    FS: "Free State",
    GP: "Gauteng",
    NL: "KwaZulu-Natal",
    LP: "Limpopo",
    MP: "Mpumalanga",
    NW: "North West",
    NC: "Northern Cape",
    WC: "Western Cape",
  },
  GS: {},
  KR: {
    "KR-26": "Busan",
    "KR-27": "Daegu",
    "KR-30": "Daejeon",
    "KR-42": "Gangwon",
    "KR-29": "Gwangju",
    "KR-41": "Gyeonggi",
    "KR-28": "Incheon",
    "KR-49": "Jeju",
    "KR-43": "Chungbuk",
    "KR-47": "Gyeongbuk",
    "KR-45": "Jeonbuk",
    "KR-50": "Sejong",
    "KR-11": "Seoul",
    "KR-44": "Chungnam",
    "KR-48": "Gyeongnam",
    "KR-46": "Jeonnam",
    "KR-31": "Ulsan",
  },
  SS: {},
  ES: {
    C: "A Coruña",
    VI: "Álava",
    AB: "Albacete",
    A: "Alicante",
    AL: "Almería",
    O: "Asturias",
    AV: "Ávila",
    BA: "Badajoz",
    PM: "Balears",
    B: "Barcelona",
    BI: "Vizcaya",
    BU: "Burgos",
    CC: "Cáceres",
    CA: "Cádiz",
    S: "Cantabria",
    CS: "Castellón",
    CE: "Ceuta",
    CR: "Ciudad Real",
    CO: "Córdoba",
    CU: "Cuenca",
    SS: "Guipúzcoa",
    GI: "Girona",
    GR: "Granada",
    GU: "Guadalajara",
    H: "Huelva",
    HU: "Huesca",
    J: "Jaén",
    LO: "La Rioja",
    GC: "Las Palmas",
    LE: "León",
    L: "Lleida",
    LU: "Lugo",
    M: "Madrid",
    MA: "Málaga",
    ML: "Melilla",
    MU: "Murcia",
    NA: "Navarra",
    OR: "Ourense",
    P: "Palencia",
    PO: "Pontevedra",
    SA: "Salamanca",
    TF: "Santa Cruz de Tenerife",
    SG: "Segovia",
    SE: "Sevilla",
    SO: "Soria",
    T: "Tarragona",
    TE: "Teruel",
    TO: "Toledo",
    V: "Valencia",
    VA: "Valladolid",
    ZA: "Zamora",
    Z: "Zaragoza",
  },
  LK: {},
  VC: {},
  SD: {},
  SR: {},
  SJ: {},
  SE: {},
  CH: {},
  SY: {},
  TW: {},
  TJ: {},
  TZ: {},
  TH: {
    "TH-37": "Amnat Charoen",
    "TH-15": "Ang Thong",
    "TH-10": "Bangkok",
    "TH-38": "Bueng Kan",
    "TH-31": "Buriram",
    "TH-24": "Chachoengsao",
    "TH-18": "Chai Nat",
    "TH-36": "Chaiyaphum",
    "TH-22": "Chanthaburi",
    "TH-50": "Chiang Mai",
    "TH-57": "Chiang Rai",
    "TH-20": "Chon Buri",
    "TH-86": "Chumphon",
    "TH-46": "Kalasin",
    "TH-62": "Kamphaeng Phet",
    "TH-71": "Kanchanaburi",
    "TH-40": "Khon Kaen",
    "TH-81": "Krabi",
    "TH-52": "Lampang",
    "TH-51": "Lamphun",
    "TH-42": "Loei",
    "TH-16": "Lopburi",
    "TH-58": "Mae Hong Son",
    "TH-44": "Maha Sarakham",
    "TH-49": "Mukdahan",
    "TH-26": "Nakhon Nayok",
    "TH-73": "Nakhon Pathom",
    "TH-48": "Nakhon Phanom",
    "TH-30": "Nakhon Ratchasima",
    "TH-60": "Nakhon Sawan",
    "TH-80": "Nakhon Si Thammarat",
    "TH-55": "Nan",
    "TH-96": "Narathiwat",
    "TH-39": "Nong Bua Lam Phu",
    "TH-43": "Nong Khai",
    "TH-12": "Nonthaburi",
    "TH-13": "Pathum Thani",
    "TH-94": "Pattani",
    "TH-S": "Pattaya",
    "TH-82": "Phangnga",
    "TH-93": "Phatthalung",
    "TH-56": "Phayao",
    "TH-67": "Phetchabun",
    "TH-76": "Phetchaburi",
    "TH-66": "Phichit",
    "TH-65": "Phitsanulok",
    "TH-14": "Phra Nakhon Si Ayutthaya",
    "TH-54": "Phrae",
    "TH-83": "Phuket",
    "TH-25": "Prachin Buri",
    "TH-77": "Prachuap Khiri Khan",
    "TH-85": "Ranong",
    "TH-70": "Ratchaburi",
    "TH-21": "Rayong",
    "TH-45": "Roi Et",
    "TH-27": "Sa Kaeo",
    "TH-47": "Sakon Nakhon",
    "TH-11": "Samut Prakan",
    "TH-74": "Samut Sakhon",
    "TH-75": "Samut Songkhram",
    "TH-19": "Saraburi",
    "TH-91": "Satun",
    "TH-33": "Sisaket",
    "TH-17": "Sing Buri",
    "TH-90": "Songkhla",
    "TH-64": "Sukhothai",
    "TH-72": "Suphan Buri",
    "TH-84": "Surat Thani",
    "TH-32": "Surin",
    "TH-63": "Tak",
    "TH-92": "Trang",
    "TH-23": "Trat",
    "TH-34": "Ubon Ratchathani",
    "TH-41": "Udon Thani",
    "TH-61": "Uthai Thani",
    "TH-53": "Uttaradit",
    "TH-95": "Yala",
    "TH-35": "Yasothon",
  },
  TL: {},
  TG: {},
  TK: {},
  TO: {},
  TT: {},
  TA: {},
  TN: {},
  TR: {},
  TM: {},
  TC: {},
  TV: {},
  UG: {},
  UA: {},
  AE: {
    AZ: "Abu Dhabi",
    AJ: "Ajman",
    DU: "Dubai",
    FU: "Fujairah",
    RK: "Ras al-Khaimah",
    SH: "Sharjah",
    UQ: "Umm al-Quwain",
  },
  GB: {
    BFP: "British Forces",
    ENG: "England",
    NIR: "Northern Ireland",
    SCT: "Scotland",
    WLS: "Wales",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AS: "American Samoa",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MH: "Marshall Islands",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    FM: "Federated States of Micronesia",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    MP: "Northern Mariana Islands",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PW: "Palau",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    VI: "Virgin Islands",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    DC: "District of Columbia",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
    AA: "Armed Forces Americas",
    AE: "Armed Forces Europe",
    AP: "Armed Forces Pacific",
  },
  UM: {},
  UY: {},
  UZ: {},
  VU: {},
  VE: {},
  VN: {},
  VG: {},
  WF: {},
  EH: {},
  YE: {},
  ZM: {},
  ZW: {},
};
